import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import moment from "moment";
import { BToast } from "bootstrap-vue";
const increment = firebase.firestore.FieldValue.increment(1);

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    user: null,
    profile: null, //was {}
    apps: [], //move to tools?
    family: [],
    heartbeats: [],
    heartbeatInfos: {},
    appsSettings: {}, //move to tools?
    appsData: {}, //move to tools?
    appsTracks: [], //move to tools?
    notifications: [],
    roles: [],
    relations: [],
    publishings: [],
    books: [], //not used
    focusesPosition: [], //not used
    focuses: [], //not used
    tags: [],
    lists: [],
    listEngine: [], //not used
    names: [],
    tools: [],
    listConnectedUsersTools: [], //not used
    listConnectedUsersNames: [], //not used
    journeys: [], //not used
    connections: [], //not used
    events: [], //not used
    namesNumbersPlaces: {},
    status: null,
    findAUser: null,
    joins: [],
    toDone: [],
    schedules: [],
    userDevice: [],
    notificationPermission: false,
    scheduleEvents: [],
    error: null,
    sessions: [],
    carePlans:[],
    guideSessions: [],
    joinTools: {},
    allImages: [],
    tourStatus: false,
    userCount: ""
  },
  getters: {
    user(state) {
      return state.user;
    },
    profile(state) {
      return state.profile;
    },
    apps(state) {
      return state.apps;
    },
    family(state) {
      return state.family;
    },
    familyActive(state) {
      return state.family && Array.isArray(state.family)
        ? state.family.filter(aMember => {
            return aMember.status && aMember.status.status
              ? aMember.status.status === "active"
              : false;
          })
        : [];
    },
    appsSettings(state) {
      return state.appsSettings;
    },
    appsData(state) {
      return state.appsData;
    },
    heartbeats(state) {
      return state.heartbeats;
    },
    heartbeatInfos(state) {
      return state.heartbeatInfos;
    },
    listRoles(state) {
      return state.roles;
    },
    listRelations(state) {
      return state.relations;
    },
    listPublishings(state) {
      return state.publishings;
    },
    listSessions(state) {
      return state.sessions;
    },
    listCarePlans(state) {
      return state.carePlans;
    },
    getLocalPublishingWithId: state => publishingId => {
      return state.listPublishings && Array.isArray(state.listPublishings)
        ? state.listPublishings.filter(aPublishing => {
            return aPublishing.id === publishingId;
          })[0]
        : null;
    },
    books(state) {
      return state.publishings;
    },
    tourStatus(state) {
      return state.tourStatus;
    },
    focuses(state) {
      return state.focuses;
    },
    tags(state) {
      return state.tags;
    },
    lists(state) {
      return state.lists;
    },
    listEngine(state) {
      return state.listEngine;
    },
    listNames(state) {
      return state.names;
    },
    listTools(state) {
      return state.tools;
    },
    listJourneys(state) {
      return state.journeys;
    },
    listConnections(state) {
      return state.connections;
    },
    listEvents(state) {
      return state.events;
    },
    listNotifications(state) {
      return state.notifications;
    },
    listNamesNumbersPlaces(state) {
      return state.lists;
    },
    status(state) {
      return state.status;
    },
    findAUser(state) {
      return state.findAUser;
    },
    joins(state) {
      return state.joins;
    },
    listConnectedUsersTools(state) {
      return state.listConnectedUsersTools;
    },
    listConnectedUsersNames(state) {
      return state.listConnectedUsersNames;
    },
    toDone(state) {
      return state.toDone;
    },
    schedules(state) {
      return state.schedules;
    },
    scheduleEvents(state) {
      return state.scheduleEvents;
    },
    joinTools(state) {
      return state.joinTools;
    },
    sessions(state) {
      return state.sessions;
    },
    careplans(state) {
      return state.careplans;
    },
    guideSessions(state) {
      return state.guideSessions;
    },
    error(state) {
      return state.error;
    },
    allImages(state) {
      return state.allImages;
    },
    userCount(state) {
      return state.userCount;
    }
  },
  actions: {
    /****** BOOKS ******/
    createBook(
      { commit, state },
      { title, subtitle, description, crew, tools, sphere, focusType, journey }
    ) {
      return new Promise((res, rej) => {
        title = title ? title : null;
        subtitle = subtitle ? subtitle : null;
        description = description ? description : null;
        crew = crew ? crew : [];
        tools = tools ? tools : [];
        sphere = sphere ? sphere : "";
        journey = journey ? journey : {};

        const db = firebase.firestore(); //Move to single place
        let collectionRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("books");

        // updating all positions for focuses ---
        collectionRef.get().then(querySnapshot => {
          querySnapshot.forEach(element => {
            const items = element.data();
            if (items.state === "ondeck") {
              collectionRef
                .doc(element.id)
                .set(
                  {
                    position: +items.position + 1
                  },
                  { merge: true }
                )
                .then(() => {
                  console.log("positions focus updated!");
                });
            }
          });
          collectionRef
            .add({
              title,
              subtitle,
              description,
              crew,
              tools,
              sphere,
              _deleted_at: null,
              position: 0,
              state: "draft",
              journey,
              log: [{ sphere, state: "draft", _created_at: new Date() }]
            })
            .then(function(docRef) {
              console.log(docRef);
              console.log("Document written with ID: ", docRef.id);
              res(docRef.path);
              localStorage.removeItem(focusType);
            })
            .catch(function(error) {
              rej(error);
              console.error("Error adding document: ", error);
            });
        });
      });
    },
    getBook({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        ref
          .get()
          .then(doc => {
            res({ ...doc.data(), focusId: doc.id });
          })
          .catch(err => {
            console.log("error in get focus: ", err);
            rej(err);
          });
      });
    },
    getBooks({ commit, state }) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("books");

      collectionRef
        .where("_deleted_at", "==", null)
        .onSnapshot(function(querySnapshot) {
          let books = [];
          querySnapshot.forEach(function(doc) {
            books.push({ ...doc.data(), bookId: doc.id });
          });

          commit("SET_BOOKS", books);
        });
    },
    updateBooks({ dispatch, commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses")
        .doc(payload.focusId);

      delete payload.focusId;
      if (!payload.state) {
        collectionRef.update({ ...payload }).then(() => {
          dispatch("updateFocusPosition");
        });
      } else {
        collectionRef.get().then(doc => {
          const generateLog = () => {
            let log = { _created_at: new Date(), _verb: "moved" };
            if (payload.sphere) {
              log.sphere = payload.sphere;
            } else {
              log.sphere = doc.data().sphere;
            }
            if (payload.state) {
              log.state = payload.state;
            } else {
              log.state = doc.data().state;
            }
            if (payload.reason_stationed)
              log.reason_stationed = payload.reason_stationed;

            return log;
          };

          collectionRef
            .update({
              state: payload.state,
              lastUpdate: new Date(),
              log: firebase.firestore.FieldValue.arrayUnion(generateLog())
            })
            .then(data => {
              console.log("successfully updated", data);
              dispatch("updateFocusPosition");
            })
            .catch(err => {
              console.log(err);
            });
        });
      }
    },
    //asynchronous or synchronus
    /****** NOTIFS -- create a Services Store******/
    sendEmail({ commit, state }, { emails }) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let batch = db.batch();
        emails.forEach(emailDoc => {
          let emailDocRef = db.collection("emails").doc(); //automatically generate unique id
          emailDoc._created_at = new Date()
          batch.set(emailDocRef, emailDoc);
        });
        batch.commit();
        res(true);
      });
    },
    /* Deprecate*/
    sendNotification({ commit, state }, payload) {
      let notifFunc = firebase.functions().httpsCallable("notificationHandler");
      notifFunc({
        ...payload,
        userFrom: {
          uid: state.user.uid,
          name: state.user.displayName
            ? state.user.displayName
            : `${state.profile.firstname} ${
                state.profile.lastname ? state.profile.lastname : ""
              }`
        }
      })
        .then(res => {
          console.log("successfully send notification", res);
        })
        .catch(err => {
          console.log("error in send notification: ", err);
        });
    },
    addNotificationFocusInvite(
      { commit, state },
      { toId, fromId, from, focus }
    ) {
      //@TODO- Move to server for Security

      const db = firebase.firestore();
      let docRef = db.doc(`users/${toId}/lists/__notifications`);
      const fullName = `${from.firstname} ${from.lastname}`;

      return docRef
        .get()
        .then(doc => {
          const newItem = {
            _created_at: new Date(),
            user_from: {
              user: db.doc(`users/${fromId}`),
              imgURL: from.imgURL,
              name: fullName
            },
            focus: db.doc(`users/${fromId}/focuses/${focus.focusId}`),
            text: `${fullName} invited you to join his journey: "${focus.destination.text1}"`,
            options: [
              { text: "Join", class: "btn btn-primary btn-sm accept" },
              { text: "Ignore", class: "btn btn-sm" }
            ],
            type: "join-invite"
          };
          if (doc.exists) {
            const items = [...doc.data().items, newItem];
            return docRef.update({
              _updated_at: new Date(),
              items: items
            });
          } else {
            return docRef.set({
              _updated_at: new Date(),
              items: [newItem]
            });
          }
        })
        .then(res => {
          console.log("successfully added notification", res);
        })
        .catch(err => {
          console.log("error in send notification: ", err);
        });
    },
    /******AUTH ******/
    signUpAction({ commit, state }, payload) {
      return new Promise((res, rej) => {
        commit("SET_STATUS", "loading");
        firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(async response => {
            console.log("response", response);
            response.user
              .updateProfile({
                displayName: payload.fullName
              })
              .then(
                async () => {
                  let user = response.user;
                  setLocalStorageUserData(response);
                  await commit("UPDATE_USER", { user });
                  commit("SET_STATUS", "success");
                },
                function(error) {
                  rej(error);
                  commit("SET_STATUS", "failure");
                  commit("SET_ERROR", error.message);
                }
              );
            // commit("UPDATE_USER", response.user);
            // commit("SET_STATUS", "success");
            // res(user);
            res(response.user);
          })
          .catch(error => {
            rej(error);
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
          });
      });
    },
    setUserName({ commit, state }, { fullName }) {
      console.log("fullname => ", fullName);
      console.log("fullname => ", state.user.uid);
      const db = firebase.firestore();
      let profileRef = db.collection("users").doc(state.user.uid);
      console.log(state.user.uid);
      profileRef.get().then(doc => {
        profileRef
          .set({
            ...doc.data(),
            firstname: fullName.split(" ")[0],
            lastname: fullName
              .split(" ")
              .slice(1)
              .join(" ")
          })
          .then(function() {
            console.log("Document successfully updated!");
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
          });
      });
    },
    signInWithGoogleAction({ commit }) {
      commit("SET_STATUS", "loading");
      return new Promise((res, rej) => {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(async response => {
            //console.log("response", response);
            let user = response.user;
            await commit("UPDATE_USER", { user });
            setLocalStorageUserData(response);
            commit("SET_STATUS", "success");
            // commit("SET_ERROR", null);
            res(response.user);
          })
          .catch(error => {
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
            rej(error);
          });
      });
    },
    signInWithFacebookAction({ commit }) {
      commit("SET_STATUS", "loading");
      return new Promise((res, rej) => {
        const provider = new firebase.auth.FacebookAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(response => {
            let user = response.user;
            commit("UPDATE_USER", { user });
            setLocalStorageUserData(response);
            commit("SET_STATUS", "success");
            // commit("SET_ERROR", null);
            res(response.user);
          })
          .catch(error => {
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
            rej(error);
          });
      });
    },
    signInWithEmailAction({ commit }, payload) {
      commit("SET_STATUS", "loading");
      return new Promise((res, rej) => {
        firebase
          .auth()
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then(response => {
            let user = response.user;
            commit("UPDATE_USER", { user });
            setLocalStorageUserData(response);
            commit("SET_STATUS", "success");
            // commit("SET_ERROR", null);
            res(response.user);
          })
          .catch(error => {
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
            rej(error);
          });
      });
    },
    signOutAction({ commit }) {
      removeLocalStorageUserData();
      firebase
        .auth()
        .signOut()
        .then(response => {
          debugger;
          commit("SET_PROFILE", null);
          commit("UPDATE_USER", null);
          commit("SET_STATUS", "success");
          commit("SET_ERROR", null);
        })
        .catch(error => {
          commit("SET_STATUS", "failure");
          commit("SET_ERROR", error.message);
        });
    },
    /* PROFILE */
    getProfile({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let docRef = db.collection("users").doc(uid ? uid : state.user.uid);

        docRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              if (!uid) {
                commit("SET_PROFILE", { ...doc.data(), userId: doc.id });
              }
              res({ ...doc.data(), userId: doc.id });
            } else {
              res({});
              //TODO: Store error for stats and Improvements
            }
          })
          .catch(function(error) {
            rej(error);
            //TODO: Store error for stats and Improvements
          });
      });
    },
    getListJoins({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let docRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__joins");

        docRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              commit("SET_JOINS", doc.data().focuses);
              res(true);
            } else {
              commit("SET_JOINS", []);
              res(true);
            }
          })
          .catch(function(error) {
            rej(error);
          });
      });
    },
    updateProfile({ commit, state }, payload) {
      return new Promise((res, rej) => {
        debugger;
        const db = firebase.firestore();
        const uid = state.user && state.user.uid ? state.user.uid : payload.uid;
        let profileRef = db.collection("users").doc(uid);
        const newDate = new Date();
        profileRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              let data = { ...doc.data() };
              //set update
              let update = {};
              if (payload.force) {
                //remove force
                delete payload.force;
                update = { ...payload, _updated_at: newDate };
              } else {
                update._updated_at = newDate;
                if (!data.firstname && payload.firstname)
                  update.firstname = payload.firstname;
                if (!data.lastname && payload.lastname)
                  update.lastname = payload.lastname;
                if (!data.imgURL && payload.imgURL)
                  update.imgURL = payload.imgURL;
                if (!data.phoneNumber && payload.phoneNumber)
                  update.phoneNumber = payload.phoneNumber;
                if (payload.isASignIn) update._signedin_at = newDate;
                if (data._provider !== payload._provider)
                  update._provider = payload._provider;
              }
              return profileRef
                .update({
                  ...update
                })
                .then(function() {
                  console.log("Document successfully updated!");
                  res(true);
                })
                .catch(function(error) {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
                  rej(error);
                });
            } else {
              profileRef.set({
                _created_at: newDate,
                email: payload.email,
                firstname: payload.firstname,
                lastname: payload.lastname,
                imgURL: payload.imgURL,
                _provider: payload._provider,
                _signedin_at: newDate
              });
              res(true);
            }
          })
          .catch(function(error) {
            rej(error);
          });
      });
    },
    /* HEARTBEAT */
    getHeartbeatInfoForUser({ commit, state }, { heartbeat }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _familyRef = db.doc(`users/${heartbeat.uid}/lists/__family`);
        _familyRef
          .get()
          .then(doc => {
            if (doc.exists) {
              //Check the family array
              const family = doc.data().family ? doc.data().family : [];

              if (Array.isArray(family)) {
                //Verify that this is a valid user
                const familyMember = family.filter(family => {
                  return family.user
                    ? family.user.userId === state.user.uid
                    : false;
                });

                if (familyMember.length === 1) {
                  //allow dupes?-- >0?

                  if (familyMember[0].status.state === "active") {
                    //@TODO:Eventually combine into one doc on the backend
                    //Include tracks

                    const _heartbeatInfoApps = db.doc(
                      `users/${heartbeat.uid}/lists/__apps`
                    );

                    const _heartbeatInfoFamily = db.doc(
                      `users/${heartbeat.uid}/lists/__family`
                    );

                    _heartbeatInfoApps.get().then(doc => {
                      let payload = {
                        uid: heartbeat.uid,
                        apps: doc.data()
                      };
                      commit("SET_HEARTBEAT_APPS", payload);
                    });
                    _heartbeatInfoFamily.get().then(doc => {
                      let payload = {
                        uid: heartbeat.uid,
                        family: doc.data()
                      };
                      commit("SET_HEARTBEAT_FAMILY", payload);
                    });
                  } else {
                    res({ status: familyMember[0].status });
                  }
                } else {
                  //Not a valid user
                  res({ status: "none" });
                }
              } else {
                //No doc available
                res({ status: "none" });
              }
            } else {
              //no doc- so fail
              res({ status: "none" });
            }
          })
          .catch(err => {
            console.log("error in saving apps in list:", err);
          });
      });
    },
    updateHeartBeatSettings({ commit, state }, payload) {
      return new Promise((res, rej) => {
        debugger;
        const db = firebase.firestore();
        const uid = state.user && state.user.uid ? state.user.uid : payload.uid;
        let profileRef = db.collection("users").doc(uid);
        const newDate = new Date();
        profileRef
            .get()
            .then(function(doc) {
              if (doc.exists) {
                let data = doc.data();
                let heartbeat = data.heartbeat ? data.heartbeat : {};
                 heartbeat.settings = payload;
                return profileRef
                    .update({
                      heartbeat:heartbeat
                    })
                    .then(function () {
                      console.log("Document successfully updated!");
                      res(true);
                    })
                    .catch(function (error) {
                      // The document probably doesn't exist.
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
              }
              })
            .catch(function(error) {
              rej(error);
            });
      });
    },
    //Seen
    updateSeen({ commit, state }, payload) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const profileRef = db.doc(
            `users/${state.user.uid}`
        );

        return  profileRef
            .set({
              seen:{[payload.type]: {
                  [payload.id]: new Date()
                }
              }
            },  { merge: true })
            .then(data => {
              res(data);
            })
            .catch(err => {
              rej(err)
            });
      });
    },
    /* CAREPLANS by HeartBeatFam - DELETE */
    addCarePlan({ commit, state }, plan) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(
            `users/${state.user.uid}/lists/__careplans`
        );
        plansRef
            .get()
            .then(doc => {
              if (doc.exists && doc.data() && doc.data().plans) {
                plansRef.update({
                  plans: [...doc.data().plans, plan],
                  _updated_at: new Date()
                });
              } else {
                plansRef.set({
                  _created_at: new Date(),
                  plans: [plan]
                });
              }
              res(true);
            })
            .catch(err => {
              console.log("error in saving care plan:", err);
              rej(err);
            });
      });
    },
    updateCarePlan({ commit, state }, {id, plan }) {
      debugger;
      console.log("p=>",id);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(
            `users/${state.user.uid}/lists/__careplans`
        );
        return plansRef.get().then(doc => {
          let data = { ...doc.data() };

          data.plans.forEach(aPlan => {
            if (aPlan.id == id) {
              aPlan._updated_at = new Date();
              aPlan.plan = plan;
            }
          });
          return plansRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    getListCarePlans({ commit, state }) {
      debugger
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _plansRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc(`__careplans`);

        _plansRef
            .get()
            .then(function(doc) {
              if (
                  doc.exists &&
                  doc.data().plans &&
                  doc.data().plans.length
              ) {
                let activePlans = doc
                    .data()
                    .plans.filter(e => e._deleted_at == null);
                commit("SET_CARE_PLANS", activePlans);
                res(doc.data().plans);
              } else {
                res([]);
              }
            })
            .catch(function(error) {
              console.error("Error in getting blogs: ", error);
              rej(error);
            });
      });
    },
    updateCarePlanStatus({ commit, state }, {plan, version, status}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const plansRef = db.doc(
            `users/${state.user.uid}/lists/__careplans`
        );
        return plansRef.get().then(doc => {
          let data = { ...doc.data() };

          //Updating
          if (data && data.plans) {
            data.plans.forEach(aPlan => {
              if (aPlan.id == plan.id) {

                if (version) {
                  if (!aPlan.versions || !Array.isArray(aPlan.versions)) aPlan.versions = [];
                  aPlan.versions.push({
                    _created_at: new Date(),
                    version
                  })
                }

                aPlan.status = status;
                aPlan._submitted_at = new Date();
              }
            });
          }
          return plansRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Care Plan Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    deleteCarePlan({ commit, state }, id) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let sessions = [];
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };
          data.sessions.forEach(aSession => {
            if (aSession.id === id) {
              aSession._deleted_at = new Date();
            }
          });
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Sessions Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    /* SESSIONS by HeartBeatFam */
    addSession({ commit, state }, session) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );

        sessionsRef
            .get()
            .then(doc => {
              if (doc.exists) {
                sessionsRef.update({
                  sessions: [...doc.data().sessions, session],
                  _updated_at: new Date()
                });
              } else {
                sessionsRef.set({
                  _created_at: new Date(),
                  sessions: [session]
                });
              }
              res(true);
            })
            .catch(err => {
              console.log("error in saving user session:", err);
              rej(err);
            });
      });
    },
    getListSessionsArch({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _userSessionsRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc("__sessions");

        _userSessionsRef
            .get()
            .then(function(doc) {
              // querySnapshot.forEach((doc) => {
              if (
                  doc.exists &&
                  doc.data().sessions &&
                  doc.data().sessions.length
              ) {
                commit("SET_SESSIONS", [...doc.data().sessions]);
                res(doc.data().sessions);
              } else {
                res(true);
              }
              // });
            })
            .catch(function(error) {
              console.error("Error get user sessions: ", error);
              rej(error);
            });
      });
    },
    getListSessions({ commit, state }) {
      return new Promise((res, rej) => {
            const db = firebase.firestore();
        let _sessionsRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("lists")
            .doc(`__sessions`);

        _sessionsRef
            .get()
            .then(function(doc) {
              if (
                  doc.exists &&
                  doc.data().sessions &&
                  doc.data().sessions.length
              ) {
                let activeSessions = doc
                    .data()
                    .sessions.filter(e => e._deleted_at == null);
                commit("SET_SESSIONS", activeSessions);
                res(doc.data().sessions);
              } else {
                res([]);
              }
            })
            .catch(function(error) {
              console.error("Error in getting blogs: ", error);
              rej(error);
            });
      });
    },
    updateSessionStatus({ commit, state }, {session, version, status}) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };

          //Updating
          if (data && data.sessions) {
            data.sessions.forEach(aSession => {
              if (aSession.id == session.id) {

                if (version) {
                  if (!aSession.versions || !Array.isArray(aSession.versions)) aSession.versions = [];
                  aSession.versions.push({
                    _created_at: new Date(),
                    version
                  })
                }

                aSession.status = status;
                aSession._submitted_at = new Date();
              }
            });
          }
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Session Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    updateSession({ commit, state }, {id, session }) {
      console.log("p=>",id);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionRef.get().then(doc => {
          let data = { ...doc.data() };

          data.sessions.forEach(aSession => {
            if (aSession.id == id) {
              aSession._updated_at = new Date();
              aSession.session = session;
            }
          });
          return sessionRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    deleteSession({ commit, state }, id) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let sessions = [];
        const sessionsRef = db.doc(
            `users/${state.user.uid}/lists/__sessions`
        );
        return sessionsRef.get().then(doc => {
          let data = { ...doc.data() };
          data.sessions.forEach(aSession => {
            if (aSession.id === id) {
              aSession._deleted_at = new Date();
            }
          });
          return sessionsRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Sessions Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    addSessonVideo({ commit, state }, { id, video }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
            `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack.video = video;
              aTrack._updated_at = new Date();
            }
          });
          return trackRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    updateSessionVideoThumbnail({ commit, state }, { id, thumbnail }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
            `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        let trackVideo = null;
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack._updated_at = new Date();
              aTrack.video._updated_at = new Date();
              aTrack.video._thumb_at = new Date();
              aTrack.video.videoThumb = thumbnail;
              aTrack._updated_at = new Date();
              trackVideo = aTrack.video;
            }
          });
          return trackRef
              .update({
                ...data
              })
              .then(function() {
                let listingTrackRef = db
                    .collection("listings/tracks_guide/items")
                    .doc(id);
                listingTrackRef
                    .get()
                    .then(function(doc) {
                      let track = doc.data();
                      track.doc.video = trackVideo;

                      return listingTrackRef
                          .update(track)
                          .then(function() {
                            console.log("Track Successfully updated!");
                            res(true);
                          })
                          .catch(function(error) {
                            console.error("Error updating Blog: ", error);
                            rej(error);
                          });
                    })
                    .catch(function(error) {
                      console.log("Error getting document:", error);
                      rej(error);
                    });
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },

    //MyApps
    saveSessionForUser({ commit, state }, {myAppId, session}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.doc(
            `users/${state.user.uid}/__apps/__sessions`
        );

        sessionsRef
            .get()
            .then(doc => {
              if (doc.exists) {
                sessionsRef.update({
                  sessions: [...doc.data().sessions, session],
                  _updated_at: new Date()
                });
              } else {
                sessionsRef.set({
                  _created_at: new Date(),
                  sessions: [session]
                });
              }
              res(true);
            })
            .catch(err => {
              console.log("error in saving user session:", err);
              rej(err);
            });
      });
    },
    /*GENERAL saves, lists, etc */
    /* PUBLISHING - AUTHOR_PUBLISHER */
    addPublishing({ commit, state }, publishing) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(
          `users/${state.user.uid}/lists/__publishings`
        );
        publishingsRef
          .get()
          .then(doc => {
            if (doc.exists) {
              publishingsRef.update({
                publishings: [...doc.data().publishings, publishing],
                _updated_at: new Date()
              });
            } else {
              publishingsRef.set({
                _created_at: new Date(),
                publishings: [publishing]
              });
            }
            res(true);
          })
          .catch(err => {
            console.log("error in saving list guide sessions1:", err);
            rej(err);
          });
      });
    },
    getListPublishings({ commit, state }) {
      return new Promise((res, rej) => {
        let publishingType = "author";

        const db = firebase.firestore();
        let _publishingsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc(`__publishings`);

        _publishingsRef
          .get()
          .then(function(doc) {
            if (
              doc.exists &&
              doc.data().publishings &&
              doc.data().publishings.length
            ) {
              let activePublishings = doc
                .data()
                .publishings.filter(e => e._deleted_at == null);
              commit("SET_PUBLISHINGS", activePublishings);
              res(doc.data().publishings);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error in getting blogs: ", error);
            rej(error);
          });
      });
    },
    submitPublishing({ commit, state }, publishing) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingRef = db.doc(
          `users/${state.user.uid}/lists/__publishings`
        );
        return publishingRef.get().then(doc => {
          let data = { ...doc.data() };
          data.publishings.forEach(aPublishing => {
            if (aPublishing.id == publishing.id) {
              aPublishing.status = "submitted";
              aPublishing._submitted_at = new Date();
            }
          });
          return publishingRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updatePublishing({ commit, state }, payload) {
      console.log("p=>", payload.id);
      console.log(JSON.stringify(payload));

      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(
          `users/${state.user.uid}/lists/__publishings`
        );
        return publishingsRef.get().then(doc => {
          let data = { ...doc.data() };

          data.publishings.forEach(aPublishing => {
            if (aPublishing.id == payload.id) {
              //Only updated what's needed
              aPublishing._updated_at = new Date();

              Object.keys(payload.updates).forEach(function eachKey(key) {
                console.log(aPublishing[key]);
                console.log(payload.updates[key]);

                if (payload.updates[key]) {
                  aPublishing[key] = payload.updates[key];
                } else {
                  if (aPublishing.hasOwnProperty(key)) {
                    aPublishing[key] = null;
                  }
                }
              });
            }
          });
          return publishingsRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    deletePublishing({ commit, state }, id) {
      //@TODO Fix Delet Publishings- it should NEVER remove the object
      //It should at the delete_at date to this object and also the listing - if available
      //and it shoudl state who deleted it and role out an notifications.
      /* return new Promise((res, rej) => {
        let publishingType = "author";

        const db = firebase.firestore();
        let publishings = [];
        const publishingsRef = db.doc(
          `users/${state.user.uid}/lists/__${publishingType}_publishings`
        );
        publishingsRef.get().then(snapShot => {
          publishings = snapShot.data().publishings;
          publishings.forEach(aPublishing => {
            if (publishings.id == publishing.id) {
              publishingsRef
                .update({
                  publishings: firebase.firestore.FieldValue.arrayRemove(aPublishing)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating publishings:", e);
                });
            }
          });
        });
      });*/
      return new Promise((res, rej) => {
        let publishingType = "author";

        const db = firebase.firestore();
        let publishings = [];
        const publishingsRef = db.doc(
          `users/${state.user.uid}/lists/__publishings`
        );
        return publishingsRef.get().then(doc => {
          let data = { ...doc.data() };
          data.publishings.forEach(aPublishing => {
            if (aPublishing.id === id) {
              //add deleted_at to archive the record
              aPublishing._deleted_at = new Date();
            }
          });
          return publishingsRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addPublishingVideo({ commit, state }, { id, video }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack.video = video;
              aTrack._updated_at = new Date();
            }
          });
          return trackRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updatePublishingVideoThumbnail({ commit, state }, { id, thumbnail }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        let trackVideo = null;
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack._updated_at = new Date();
              aTrack.video._updated_at = new Date();
              aTrack.video._thumb_at = new Date();
              aTrack.video.videoThumb = thumbnail;
              aTrack._updated_at = new Date();
              trackVideo = aTrack.video;
            }
          });
          return trackRef
            .update({
              ...data
            })
            .then(function() {
              let listingTrackRef = db
                .collection("listings/tracks_guide/items")
                .doc(id);
              listingTrackRef
                .get()
                .then(function(doc) {
                  let track = doc.data();
                  track.doc.video = trackVideo;

                  return listingTrackRef
                    .update(track)
                    .then(function() {
                      console.log("Track Successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating Blog: ", error);
                      rej(error);
                    });
                })
                .catch(function(error) {
                  console.log("Error getting document:", error);
                  rej(error);
                });
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },

    /* PUBLISHING - READER */
    getCollectedCornerPublishings({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userShelfRef = db
          .collection("users")
          .doc(uid)
          .collection("lists")
          .doc("__corner_collects");

        userShelfRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().corners && doc.data().corners.length) {
              res(doc.data().corners);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error(
              "Error get user collected corner publishings: ",
              error
            );
            rej(error);
          });
      });
    },
    collectCornerPublishing({ commit, state }, corner) {
      console.log("IN COLLECT PUBLISHINGS");
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let shelfRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__corner_collects");
        shelfRef.get().then(doc => {
          if (doc.exists) {
            let existingCornerPublishings = doc.data().corner;
            existingCornerPublishings.push(corner);
            shelfRef
              .update({
                _updated_at: new Date(),
                corners: existingCornerPublishings
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            shelfRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                _deleted_at: null,
                corners: [corner]
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    uncollectCornerPublishing({ commit, state }, corner) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let corners = [];
        let shelfRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__corner_collects");
        shelfRef.get().then(snapShot => {
          corners = snapShot.data().corners;
          corners.forEach(aCorner => {
            console.log(`APubId ${aCorner.id} | PublishingId ${corner.id}`);

            if (aCorner.id == corner.id) {
              shelfRef
                .update({
                  corners: firebase.firestore.FieldValue.arrayRemove(aCorner)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating follow:", e);
                });
            }
          });
        });
      });
    },

    /*FORM */
    saveFormResponse({ commit, state }, payload) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let docCollectionRef = db
            .collection("forms")
            .doc(payload.formId)
            .collection("items");

        return docCollectionRef.add({
          _created_at: new Date(), ... payload })
            .then((resp)=>{
              res(resp);
            }).catch((error)=>{
              rej(error);
            })
      });
    },
    updateStatusForm({ commit, state }, payload) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const uid = state.user && state.user.uid ? state.user.uid : payload.uid;
        let profileRef = db.collection("users").doc(uid);
        const newDate = new Date();
        profileRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              let data = { ...doc.data() };
              //set update
              let update = {};
              if (payload.force) {
                //remove force
                delete payload.force;
                update = { ...payload, _updated_at: newDate };
              } else {
                update._updated_at = newDate;
                if (data.statuses) {
                  update.statuses = [...data.statuses, payload];
                } else {
                  update.statuses = [payload];
                }
              }
              return profileRef
                .update({
                  ...update
                })
                .then(function() {
                  console.log("Document successfully updated!");
                  res(true);
                })
                .catch(function(error) {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
                  rej(error);
                });
            } else {
              profileRef.set({
                statuses: [payload]
              });
              res(true);
            }
          })
          .catch(function(error) {
            //TODO: Store error for stats and Improvements
          });
      });
    },
    updateStatusFormOld({ commit, state }, payload) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userRef = db.collection("users").doc(state.user.uid);

        return userRef.get().then(doc => {
          let data = { ...doc.data() };
          console.log(`DATA STATUS ${data.status}`);

          if (data.statuses) {
            return userRef
              .update({
                statuses: true
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                rej(error);
              });
          } else {
            /*return userRef
              .set({
                statuses: "what"
              }).then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                rej(error);
              });*/
          }
        });
      });
    },

    /*DASHBOARD - GENERAL */
    addUpdateProfileDashboardForType({ commit, state }, { type, form }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userRef = db.collection("users").doc(state.user.uid);

        return userRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards[type]) {
            data._dashboards[type] = {
              ...data._dashboards[type],
              ...form,
              _updated_at: new Date()
            };
          } else {
            data._dashboards = {
              [type]: {},
              developer: {}
            };
            data._dashboards[type] = {
              _created_at: new Date(),
              ...form
            };
          }
          return userRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
        });
      });
    },
    /* GUIDE */
    updateProfileDashboardGuide({ commit, state }, { guide }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.guide) {
            data._dashboards.guide = {
              ...data._dashboards.guide,
              ...guide,
              _updated_at: new Date()
            };
          } else {
            data._dashboards = {
              guide: {},
              developer: {}
            };
            data._dashboards.guide = {
              _created_at: new Date(),
              ...guide
            };
          }
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateGuideVideoThumbnail({ commit, state }, thumbnail) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.guide._updated_at = new Date();
          data._dashboards.guide.video._updated_at = new Date();
          data._dashboards.guide.video._thumb_at = new Date();
          data._dashboards.guide.video.videoThumb = thumbnail;
          return guideRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateTourStatus({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let tourRef = db.collection("users").doc(state.user.uid);
        return tourRef.get().then(doc => {
          let data = { ...doc.data() };
          data._tour = {};
          data._tour.joins = true;
          return tourRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              commit("SET_TOUR_STATUS", true);
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    getTourStatus({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let tourRef = db.collection("users").doc(state.user.uid);
        return tourRef
          .get()
          .then(doc => {
            let data = { ...doc.data() };
            if (data._tour && data._tour.joins) {
              commit("SET_TOUR_STATUS", data._tour.joins);
            }
            res(true);
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    publishedGuideInfo({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.guide) {
            data._dashboards.guide = {
              ...data._dashboards.guide,
              _published_at: new Date()
            };
          }
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },

    /* BLOGGER */
    updateProfileDashboardBlogger({ commit, state }, { blogger }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.blogger) {
            data._dashboards.blogger = {
              ...data._dashboards.blogger,
              ...blogger,
              _updated_at: new Date()
            };
          } else {
            data._dashboards = {
              blogger: {},
              guide: {},
              developer: {}
            };
            data._dashboards.blogger = {
              _created_at: new Date(),
              ...blogger
            };
          }
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateBloggerVideoThumbnail({ commit, state }, thumbnail) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.blogger._updated_at = new Date();
          data._dashboards.blogger.video._updated_at = new Date();
          data._dashboards.blogger.video._thumb_at = new Date();
          data._dashboards.blogger.video.videoThumb = thumbnail;
          return bloggerRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    publishedBloggerInfo({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("users").doc(state.user.uid);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.blogger) {
            data._dashboards.blogger = {
              ...data._dashboards.blogger,
              _published_at: new Date()
            };
          }
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    saveBloggerProfileName({ commit, state }, profileName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.blogger = {
            ...data._dashboards.blogger,
            _updated_at: new Date(),
            profileName: profileName
          };
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateBloggerDashboard({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            blogger: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },

    /* BLOGGER-ARTICLE */
    createArticle({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const blogsRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_articles`
        );
        blogsRef
          .get()
          .then(doc => {
            if (doc.exists) {
              blogsRef.update({
                blogs: [...doc.data().blogs, blog],
                _updated_at: new Date()
              });
            } else {
              blogsRef.set({
                _created_at: new Date(),
                blogs: [blog]
              });
            }
            res(true);
          })
          .catch(err => {
            console.log("error in saving list guide sessions1:", err);
          });
      });
    },
    getListArticles({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _guideSessionsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blogger_articles");

        _guideSessionsRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().blogs && doc.data().blogs.length) {
              res(doc.data().blogs);
            } else {
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error in getting blogs: ", error);
            rej(error);
          });
      });
    },
    updateArticle({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const bloggerRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_articles`
        );
        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data.blogs.forEach(aBlog => {
            if (aBlog.id == blog.id) {
              aBlog._updated_at = new Date();
              aBlog.title = blog.title;
              aBlog.synopsis = blog.synopsis;
              aBlog.spheres = blog.spheres;
              aBlog.seo = blog.seo;
              aBlog.tools = blog.tools;
              aBlog.guides = blog.guides;
              aBlog.connections = blog.connections;
            }
          });
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    deleteArticle({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogs = [];
        const blogsRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_articles`
        );
        blogsRef.get().then(snapShot => {
          blogs = snapShot.data().blogs;
          blogs.forEach(aBlog => {
            if (aBlog.id == blog.id) {
              blogsRef
                .update({
                  blogs: firebase.firestore.FieldValue.arrayRemove(aBlog)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating blog:", e);
                });
            }
          });
        });
      });
    },
    submitArticle({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const bloggerRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_articles`
        );
        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data.blogs.forEach(aBlog => {
            if (aBlog.id == blog.id) {
              aBlog.status = "submitted";
              aBlog._submitted_at = new Date();
            }
          });
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addArticleVideo({ commit, state }, { id, video }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const bloggerRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_articles`
        );
        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data.blogs.forEach(aBlog => {
            if (aBlog.id == id) {
              aBlog.video = video;
              aBlog._updated_at = new Date();
            }
          });
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateArticleVideoThumbnail({ commit, state }, { id, thumbnail }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const bloggerRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_articles`
        );
        let blogVideo = null;
        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data.blogs.forEach(aBlog => {
            if (aBlog.id == id) {
              aBlog._updated_at = new Date();
              aBlog.video._updated_at = new Date();
              aBlog.video._thumb_at = new Date();
              aBlog.video.videoThumb = thumbnail;
              aBlog._updated_at = new Date();
              blogVideo = aBlog.video;
            }
          });
          return bloggerRef
            .update({
              ...data
            })
            .then(function() {
              let listingBlogRef = db
                .collection("listings/blogs/items")
                .doc(id);
              listingBlogRef
                .get()
                .then(function(doc) {
                  let blog = doc.data();
                  blog.doc.video = blogVideo;

                  return listingBlogRef
                    .update(blog)
                    .then(function() {
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating Blog: ", error);
                      rej(error);
                    });
                })
                .catch(function(error) {
                  console.log("Error getting document:", error);
                  rej(error);
                });
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },

    /* APP - MOVE TO TOOLS STATE and pass user */
    updateApps({ commit, state }, apps) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _listAppsRef = db.doc(`users/${state.user.uid}/lists/__apps`);
        _listAppsRef
          .get()
          .then(doc => {
            let appsArray = Array.isArray(apps) ? apps : [apps];
            if (doc.exists) {
              _listAppsRef.update({
                apps: [...doc.data().apps, ...appsArray],
                _updated_at: new Date()
              });
            } else {
              _listAppsRef.set({
                _created_at: new Date(),
                apps: Array.isArray(apps) ? apps : [apps]
              });
            }
            res(true);
          })
          .then(res => {
            //email user from each app downloaded depending on settings of app and user
            if (emails && Array.isArray(emails)) {
              let batch = db.batch();
              emails.forEach(doc => {
                let emailDocRef = db.collection("emails").doc(); //automatically generate unique id
                batch.set(emailDocRef, doc);
              });
              batch.commit();
              res(true);
            }
          })
          .catch(err => {
            console.log("error in saving apps in list:", err);
          });
      });
    },
    getListApps({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _appsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc(`__apps`);

        _appsRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().apps && doc.data().apps.length) {
              let activeApps = doc
                .data()
                .apps.filter(e => e._deleted_at == null);
              commit("SET_APPS", activeApps);
              res(doc.data().apps);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error in getting apps: ", error);
            rej(error);
          });
      });
    },
    updateAppTracks({ commit, state }, { app, tracks, ip, viewingId }) {
      return new Promise((res, rej) => {
        if (app && app.toolId && tracks) {
          const db = firebase.firestore();
          //@TODO Save _created_at and _updated_at on top level.
          db.collection("users")
            .doc(viewingId)
            .collection("lists")
            .doc("__apps")
            .collection("tracks")
            .add({
              _created_at: new Date(),
              appId: app.toolId,
              tracks: Array.isArray(tracks) ? tracks : [tracks],
              ip: ip
            })
            .then(docRef => {
              res(docRef.id);
            })
            .catch(error => {
              console.error("Error adding document: ", error);
              rej(error);
            });
        }
      });
    },

    /*SETTINGS */
    getAppSettingsForAppId({ commit, state }, {appId, viewingId}) {
      return new Promise((res, rej) => {
        if (appId) {
          const db = firebase.firestore();
          const _listAppsSettingsRef = db
            .collection(`users/${viewingId}/lists/__apps/settings/`)
            .doc(appId);
          _listAppsSettingsRef
            .get()
            .then(doc => {
              if (doc.exists) {
                let payload = {
                  appId: appId,
                  settings: doc.data()
                };
                commit("SET_APPS_SETTINGS", payload);
                res(doc.data());
              } else {
                res({});
              }
            })
            .catch(err => {
              console.log("error in updating settings :", err);
              rej(err);
            });
        }
      });
    },
    updateAppSettings({ commit, state }, { app, settings, viewingId }) {
      return new Promise((res, rej) => {
        if (app && settings) {
          const db = firebase.firestore();
          const _listAppsSettingsRef = db
            .collection(`users/${viewingId}/lists/__apps/settings/`)
            .doc(app.toolId);
          _listAppsSettingsRef
            .get()
            .then(doc => {
              if (doc.exists) {
                settings._updated_at = new Date();
                _listAppsSettingsRef.update(settings);
              } else {
                if (app.name) settings.name = app.name;
                settings._created_at = new Date();
                _listAppsSettingsRef.set(settings);
              }
              res(true);
            })
            .catch(err => {
              console.log("error in updating settings :", err);
              rej(err);
            });
        }
      });
    },
    getAppUserDataForAppId({ commit, state }, { appId, viewingId} ) {
      return new Promise((res, rej) => {
        if (appId) {
          const db = firebase.firestore();
          const _listAppsDataRef = db
            .collection(`users/${viewingId}/lists/__apps/data/`)
            .doc(appId);
          _listAppsDataRef
            .get()
            .then(doc => {
              if (doc.exists) {
                let payload = {
                  appId: appId,
                  data: doc.data()
                };
                commit("SET_APPS_DATA", payload);
                res(doc.data());
              } else {
                res({});
              }
            })
            .catch(err => {
              console.log("error in updating settings :", err);
              rej(err);
            });
        }
      });
    },
    updateAppUserData({ commit, state }, { tool, data, key, viewingId }) {
      return new Promise((res, rej) => {
        debugger;
        if (tool && data) {
          const db = firebase.firestore();
          const _listAppsDataRef = db
            .collection(`users/${viewingId}/lists/__apps/data/`)
            .doc(tool.toolId);
          _listAppsDataRef
            .get()
            .then(doc => {
              if (doc.exists) {
                data._updated_at = new Date();
                //Temp
                let existingItemsForKey = doc.data()[key];

                //let key = 'playlist';
                const existingItems = Array.isArray(existingItemsForKey)
                  ? Array.isArray(existingItemsForKey)
                  : [Array.isArray(existingItemsForKey)];
                const newItems = Array.isArray(data[key])
                  ? data[key]
                  : [data[key]];

                if (existingItemsForKey) {
                  _listAppsDataRef.update({
                    [key]: [...existingItemsForKey, ...newItems],
                    _updated_at: new Date()
                  });
                } else {
                  //First time for this key;
                  _listAppsDataRef.set({ [key]: data[key] }, { merge: true });
                }
              } else {
                if (tool.name) data.name = tool.name;
                data._created_at = new Date();
                _listAppsDataRef.set(data);
              }
              res(true);
            })
            .catch(err => {
              console.log("error in updating data :", err);
              rej(err);
            });
        }
      });
    },
    /* FAMILY- UPDATE */
    updateFamily({ commit, state }, { familyMembers, invites }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _listFamilyRef = db.doc(`users/${state.user.uid}/lists/__family`);
        const _invitesRef = db.doc(`app/services`);
        debugger;
        _listFamilyRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let familyArray = Array.isArray(familyMembers)
                ? familyMembers
                : [familyMembers];
              _listFamilyRef.update({
                family: [...doc.data().family, ...familyArray],
                _updated_at: new Date()
              });
            } else {
              _listFamilyRef.set({
                _created_at: new Date(),
                family: Array.isArray(familyMembers)
                  ? familyMembers
                  : [familyMembers]
              });
            }
            res(doc);
          })
          .then(res => {
            //InvitesRef - Divide up to run in parallel
            _invitesRef.get().then(res => {
              let batch = db.batch();
              invites.forEach(doc => {
                let invitesDocRef = db.collection("invites").doc(); //automatically generate unique id
                batch.set(invitesDocRef, doc);
              });
              batch.commit();
              res(true);
            });
          })
          .catch(err => {
            console.log("error in saving :", err);
          });
      });
    },
    getListFamily({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _familyRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc(`__family`);

        _familyRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().family && doc.data().family.length) {
              let activeFamily = doc
                .data()
                .family.filter(e => e._deleted_at == null);
              commit("SET_FAMILY", activeFamily);
              res(doc.data().family);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error in getting family: ", error);
            rej(error);
          });
      });
    },
    /* CARE-FAMILY */
    updateHeartbeats({ commit, state }, users) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _listFamilyRef = db.doc(`users/${state.user.uid}/lists/__family`);
        _listFamilyRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let familyArray = Array.isArray(users) ? users : [users];
              _listFamilyRef.update({
                family: [...doc.data().family, ...familyArray],
                _updated_at: new Date()
              });
            } else {
              _listFamilyRef.set({
                _created_at: new Date(),
                family: Array.isArray(users) ? users : [users]
              });
            }
            res(true);
          })
          .catch(err => {
            console.log("error in saving family:", err);
          });
      });
    },
    getListHeartbeats({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _heartbeatRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc(`__heartbeats`);

        _heartbeatRef
          .get()
          .then(function(doc) {
            if (
              doc.exists &&
              doc.data().heartbeats &&
              doc.data().heartbeats.length
            ) {
              commit("SET_HEARTBEATS", doc.data().heartbeats);
              res(doc.data().heartbeats);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error in getting heartbeats: ", error);
            rej(error);
          });
      });
    },
    /* COMPANY */
    updateProfileDashboardCompany({ commit, state }, { company }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companyRef = db.collection("users").doc(state.user.uid);

        return companyRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.company) {
            data._dashboards.company = {
              ...data._dashboards.company,
              ...company,
              _updated_at: new Date()
            };
          } else {
            data._dashboards = {
              company: {},
              guide: {},
              developer: {}
            };
            data._dashboards.blogger = {
              _created_at: new Date(),
              ...company
            };
          }
          return companyRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    saveCompanyProfileName({ commit, state }, profileName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userRef = db.collection("users").doc(state.user.uid);
        return userRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.companies = {
            ...data._dashboards.companies,
            _updated_at: new Date(),
            _updated_by: "User",
            profileName: profileName
          };
          return userRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateCompanyVideoThumbnail({ commit, state }, thumbnail) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companyRef = db.collection("users").doc(state.user.uid);

        return companyRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.company._updated_at = new Date();
          data._dashboards.company.video._updated_at = new Date();
          data._dashboards.company.video._thumb_at = new Date();
          data._dashboards.company.video.videoThumb = thumbnail;
          return companyRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    publishedCompanyInfo({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companyRef = db.collection("users").doc(state.user.uid);

        return companyRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.company) {
            data._dashboards.company = {
              ...data._dashboards.company,
              _published_at: new Date()
            };
          }
          return companyRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    getUserFromDb({ commit, state }, email) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let collectionRef = db.collection("users");
        collectionRef
          .where("email", "==", email)
          .get()
          .then(function(querySnapshot) {
            let users = [];
            querySnapshot.forEach(function(doc) {
              users.push({ ...doc.data(), userId: doc.id });
            });
            res(users);
          })
          .catch(err => {
            console.log("error in getting user: ", err);
            rej(err);
          });
      });
    },
    getFocus({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        ref
          .get()
          .then(doc => {
            res({ ...doc.data(), focusId: doc.id });
          })
          .catch(err => {
            console.log("error in get focus: ", err);
            rej(err);
          });
      });
    },
    getFocuses({ commit, state }) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses");

      collectionRef
        .where("_deleted_at", "==", null)
        // .get()
        .onSnapshot(function(querySnapshot) {
          let focuses = [];
          querySnapshot.forEach(function(doc) {
            focuses.push({ ...doc.data(), focusId: doc.id });
          });

          commit("SET_FOCUSES", focuses);
        });
      // .then(function(querySnapshot) {
      //   let focuses = [];
      //   querySnapshot.forEach(function(doc) {
      //     focuses.push({ ...doc.data(), focusId: doc.id });
      //   });
      //   commit("SET_FOCUSES", focuses);
      // })
      // .catch(function(error) {
      //   //TODO: Store error for stats and Improvements
      // });
    },
    updateFocuses({ dispatch, commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses")
        .doc(payload.focusId);

      delete payload.focusId;
      if (!payload.state) {
        collectionRef.update({ ...payload }).then(() => {
          dispatch("updateFocusPosition");
        });
      } else {
        collectionRef.get().then(doc => {
          const generateLog = () => {
            let log = { _created_at: new Date(), _verb: "moved" };
            if (payload.sphere) {
              log.sphere = payload.sphere;
            } else {
              log.sphere = doc.data().sphere;
            }
            if (payload.state) {
              log.state = payload.state;
            } else {
              log.state = doc.data().state;
            }
            if (payload.reason_stationed)
              log.reason_stationed = payload.reason_stationed;

            return log;
          };

          collectionRef
            .update({
              state: payload.state,
              lastUpdate: new Date(),
              log: firebase.firestore.FieldValue.arrayUnion(generateLog())
            })
            .then(data => {
              console.log("successfully updated", data);
              dispatch("updateFocusPosition");
            })
            .catch(err => {
              console.log(err);
            });
        });
      }
    },
    async updateFocusPosition({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        const items = state.focusesPosition;
        const copy = state.focuses;

        if (items.length > 0) {
          items.forEach(item => {
            if (item.items.length > 0) {
              item.items.forEach((root, index) => {
                const getIndex = copy.findIndex(
                  val => val.focusId === root.focusId
                );

                if (getIndex !== -1) {
                  copy[getIndex].state = item.from;
                  if (copy[getIndex].position === undefined) {
                    copy[getIndex] = Object.assign(copy[getIndex], {
                      position: index
                    });
                  } else {
                    copy[getIndex].position = index;
                  }
                }
              });
            }
          });
        }

        dispatch("saveFocusPosition");

        state.focusesPosition = [];
        resolve();
      });
    },
    saveFocusPosition({ commit, state }) {
      const db = firebase.firestore();

      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses");

      console.log("save focus position", state.focuses);

      state.focuses.forEach((val, index) => {
        collectionRef
          .doc(val.focusId)
          .set(
            {
              state: val.state,
              position: val.position !== undefined ? val.position : index
            },
            { merge: true }
          )
          .then(() => {
            console.log("updated");
            // resolve();
          })
          .catch(err => console.log(err));
      });
    },
    activateFocus(
      { commit, state },
      { focusId, listEmail, crewDetails, virtualState }
    ) {
      const db = firebase.firestore(); //Move to single place
      let focusesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses")
        .doc(focusId);
      let namesNumbersPlacesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");
      let toSaveInNamesNumbersPlaces = [];
      console.log("focusesRef", focusesRef);
      focusesRef
        .get()
        .then(doc => {
          let crews = [...doc.data().crew];
          let counterIndexUnconnected = 0;
          crews = crews.map(el => {
            if (!el._joined_at) {
              let output = {
                ...el,
                _notified_at: new Date(),
                email: listEmail[counterIndexUnconnected],
                join_status: "notified",
                _type: virtualState[counterIndexUnconnected]
              };

              if (crewDetails[counterIndexUnconnected]) {
                let outputToSend = {
                  ...output
                };
                let connection = {
                  ...crewDetails[counterIndexUnconnected],
                  _names_numbers_places_id: el._names_numbers_places_id,
                  // uid: undefined,
                  // joins: undefined,
                  // _boarded_at: undefined,
                  user: db.doc(
                    "users/" + crewDetails[counterIndexUnconnected].uid
                  )
                };
                delete outputToSend.uid;
                delete connection.uid;
                delete connection.joins;
                delete connection._boarded_at;
                delete connection.shef;
                toSaveInNamesNumbersPlaces.push(connection);
                counterIndexUnconnected++;
                return outputToSend;
              } else {
                counterIndexUnconnected++;
                return output;
              }
            } else {
              return el;
            }
          });
          return focusesRef.get().then(doc => {
            let data = { ...doc.data() };
            data._activated_at = new Date();
            return (
              focusesRef
                .update({
                  ...data
                })

                // return focusesRef
                //   .update({
                //     _activated_at: new Date(),
                //     crew: crews
                //   })
                .then(() => {
                  if (toSaveInNamesNumbersPlaces.length) {
                    return namesNumbersPlacesRef.get().then(doc => {
                      let items = [...doc.data().items];
                      let listIdToUpdate = toSaveInNamesNumbersPlaces.map(
                        el => el._names_numbers_places_id
                      );
                      let newItems = items.map(el => {
                        if (listIdToUpdate.includes(el.uid)) {
                          return {
                            ...el,
                            connection: {
                              ...toSaveInNamesNumbersPlaces[
                                listIdToUpdate.indexOf(el.uid)
                              ]
                            }
                          };
                        } else {
                          return el;
                        }
                      });
                      return namesNumbersPlacesRef
                        .update({
                          items: newItems
                        })
                        .then(() => {
                          console.log(
                            "successfully saves connection in _names_numbers_places"
                          );
                        });
                    });
                  }
                })
            );
          });
        })
        .catch(err => {
          console.log("error on activation focus: ", err);
        });
    },
    getTags({ commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("tags")
        .doc(state.user.uid)
        .collection("lists");

      collectionRef
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            commit("SET_TAGS", doc.data());
          });
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getLists({ commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists");
      collectionRef
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            commit("SET_LISTS", doc.data());
          });
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getListEngines({ commit, state }) {
      const db = firebase.firestore();
      let docEngine = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists")
        .doc("__engines");

      docEngine
        .get()
        .then(function(doc) {
          if (doc.exists) {
            commit("SET_LIST_ENGINE", doc.data().items);
          } else {
            //TODO: Store error for stats and Improvements
            commit("SET_LIST_ENGINE", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getListNamesNumbersPlaces({ commit, state }) {
      const db = firebase.firestore();
      let docNamesNumbersPlacesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");

      docNamesNumbersPlacesRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            commit("SET_NAMES_NUMBERS_PLACES", doc.data());
          } else {
            //TODO: Store error for stats and Improvements
            commit("SET_NAMES_NUMBERS_PLACES", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getListNames({ commit, state }) {
      const db = firebase.firestore();
      let docNamesNumbersPlacesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");

      docNamesNumbersPlacesRef
        .get()
        .then(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_NAMES", doc.data().items);
          } else {
            commit("SET_NAMES", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
          console.error("Error get tools: ", error);
        });
    },
    /* TOOLS */
    getListTools({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_tools");

        toolsRef
          // .get()
          // .then
          .onSnapshot(function(doc) {
            if (doc.exists && doc.data().items && doc.data().items.length) {
              let items = doc.data().items;
              commit("SET_TOOLS", doc.data().items);
              res(doc.data().items);
            } else {
              commit("SET_TOOLS", []);
              res(true);
            }
          });
        // .catch(function(error) {
        //   console.error("Error get names: ", error);
        // });
      });
    },
    getJoinTools({ commit, state }, { uid }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(uid)
          .collection("tags")
          .doc("_tools");

        toolsRef.onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_JOIN_TOOLS", { uid, tools: doc.data().items });
            res(doc.data().items);
          }
        });
      });
    },
    getListToolsOtherUser({ commit, state }, { uid }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(uid)
          .collection("tags")
          .doc("_tools");

        toolsRef.onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_LIST_TOOLS_CONNECTED_USERS", {
              uid: uid,
              items: doc.data().items
            });
            res({ uid: uid, items: doc.data().items });
          }
        });
      });
    },
    getListNamesOtherUser({ commit, state }, { uid }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let namessRef = db
          .collection("users")
          .doc(uid)
          .collection("tags")
          .doc("_names_numbers_places");

        namessRef.onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_LIST_NAMES_CONNECTED_USERS", {
              uid: uid,
              items: doc.data().items
            });
            res({ uid: uid, items: doc.data().items });
          }
        });
      });
    },
    getListJourneys({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        toolsRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().items && doc.data().items.length) {
              let items = doc.data().items;
              commit("SET_JOURNEYS", items);
              res(doc.data());
            } else {
              commit("SET_JOURNEYS", []);
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error get journeys: ", error);
          });
      });
    },
    getListConnections({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        toolsRef
          .get()
          .then(function(doc) {
            if (
              doc.exists &&
              doc.data().connections &&
              doc.data().connections.length
            ) {
              let connections = doc.data().connections;
              console.log("getting connections", connections);
              commit("SET_CONNECTIONS", connections);
              res(doc.data());
            } else {
              // commit("SET_JOURNEYS", []);
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error get connections: ", error);
          });
      });
    },
    /* SESSIONS */
    getListSessionsOld({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _userSessionsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__sessions");

        _userSessionsRef
          .get()
          .then(function(doc) {
            // querySnapshot.forEach((doc) => {
            if (
              doc.exists &&
              doc.data().sessions &&
              doc.data().sessions.length
            ) {
              commit("SET_SESSIONS", [...doc.data().sessions]);
              res(doc.data().sessions);
            } else {
              res(true);
            }
            // });
          })
          .catch(function(error) {
            console.error("Error get user sessions: ", error);
            rej(error);
          });
      });
    },
    getListGuideSessions({ commit, state }, id) {
      let uid = null;
      if (id) {
        uid = id;
      } else {
        uid = state.user.uid;
      }
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _guideSessionsRef = db
          .collection("users")
          .doc(uid)
          .collection("lists")
          .doc("__guide_sessions");

        _guideSessionsRef
          .get()
          .then(function(doc) {
            // querySnapshot.forEach((doc) => {
            if (
              doc.exists &&
              doc.data().sessions &&
              doc.data().sessions.length
            ) {
              commit("SET_GUIDE_SESSIONS", [...doc.data().sessions]);
              res(doc.data().sessions);
            } else {
              res(true);
            }
            // });
          })
          .catch(function(error) {
            console.error("Error get guide sessions: ", error);
            rej(error);
          });
      });
    },
    getListNotifications({ commit, state }) {
      const db = firebase.firestore();
      let __notificationsRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists")
        .doc("__notifications");

      __notificationsRef
        // .get()
        .onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            // let items = doc.data().items;
            commit("SET_NOTIFICATIONS", doc.data().items);
          } else {
            commit("SET_NOTIFICATIONS", []);
          }
        });
      // .then(function(doc) {
      // })
      // .catch(function(error) {
      // console.error("Error get notifications: ", error);
      // });
    },
    getUserProfile({ commit, state }, ref) {
      return new Promise((res, rej) => {
        const userRef = ref;
        userRef
          .get()
          .then(doc => {
            res(doc.data());
          })
          .catch(e => {
            rej(e);
            console.log(e);
          });
      });
    },
    getListRoles({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let rolesRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_roles");

        rolesRef.get().then(doc => {
          if (doc.exists) {
            res(doc.data().items);
            commit("SET_ROLES", { roles: doc.data().items });
          } else {
            commit("SET_ROLES", { roles: [] });
          }
        });
      });
    },
    getListRelations({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let relationsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_relations");

        relationsRef.get().then(doc => {
          if (doc.exists) {
            res(doc.data().items);
            commit("SET_RELATIONS", { roles: doc.data().items });
          } else {
            commit("SET_RELATIONS", { roles: [] });
          }
        });
      });
    },
    /* SCHEDULES */
    addSchedule({ commit, state }, { schedule }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const schedulePath = `users/${state.user.uid}/lists/__schedule`;
        const scheduleRef = db.doc(schedulePath);
        return scheduleRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let schedule_name = Date.now();
              scheduleRef.update({
                _schedules: firebase.firestore.FieldValue.arrayUnion({
                  schedule_name: schedule_name,
                  _created_at: new Date()
                })
              });
            } else {
              return scheduleRef
                .set({
                  _schedules: {
                    schedule_name: Date.now(),
                    _created_at: new Date()
                  }
                })
                .then(() => {
                  console.log("successfully saved a schedule event");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save schedule event: ", err);
            rej(err);
          });
      });
    },
    getSchedules({ commit, state }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedules`);
        scheduleRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            commit("SET_SCHEDULES", { schedules: snapshot.data()._schedules });
            res(snapshot.data().items);
          } else {
            res([]);
          }
        });
      });
    },
    addScheduleEvent({ commit, state }, { scheduleEvent }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedule`);
        return scheduleRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let scheduleEvents = [...doc.data().items];
              return scheduleRef
                .update({
                  items: [...scheduleEvents, { ...scheduleEvent }]
                })
                .then(() => {
                  console.log("successfully a schedule event");
                  res(true);
                });
            } else {
              return scheduleRef
                .set({
                  _created_at: new Date(),
                  items: [{ ...scheduleEvent }]
                })
                .then(() => {
                  console.log("successfully saved a schedule event");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save schedule event: ", err);
            rej(err);
          });
      });
    },
    getScheduleEvents({ commit, state }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedule`);
        scheduleRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            commit("SET_SCHEDULE_EVENTS", {
              scheduleEvents: snapshot.data().items
            });
            res(snapshot.data().items);
          } else {
            res([]);
          }
        });
      });
    },
    removeScheduleEvent({ commit, state }, { scheduleEvent }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedule`);
        return scheduleRef
          .get()
          .then(doc => {
            let scheduleEvents = [...doc.data().items];
            scheduleEvents = scheduleEvents.map(el => {
              if (el.text === scheduleEvent.text) {
                return {
                  ...el,
                  _deleted_at: new Date()
                };
              }
              return el;
            });
            return scheduleRef
              .update({
                items: scheduleRef
              })
              .then(() => {
                console.log("successfully removed Schedule Event");
                res(true);
              });
          })
          .catch(err => {
            console.log("error in removing Schedule Event: ", err);
            rej(err);
          });
      });
    },
    addFocusedJourney(
      { commit, state },
      { destination, engines, crew, tools, sphere, focusType, journey }
    ) {
      return new Promise((res, rej) => {
        destination = destination ? destination : {};
        crew = crew ? crew : [];
        tools = tools ? tools : [];
        sphere = sphere ? sphere : "";
        journey = journey ? journey : {};

        const db = firebase.firestore(); //Move to single place
        let collectionRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses");

        // updating all positions for focuses ---
        collectionRef.get().then(querySnapshot => {
          querySnapshot.forEach(element => {
            const items = element.data();
            if (items.state === "ondeck") {
              collectionRef
                .doc(element.id)
                .set(
                  {
                    position: +items.position + 1
                  },
                  { merge: true }
                )
                .then(() => {
                  console.log("positions focus updated!");
                });
            }
          });
          collectionRef
            .add({
              destination,
              engines,
              crew,
              tools,
              sphere,
              _deleted_at: null,
              position: 0,
              state: "ondeck",
              journey,
              log: [{ sphere, state: "ondeck", _created_at: new Date() }]
            })
            .then(function(docRef) {
              console.log(docRef);
              console.log("Document written with ID: ", docRef.id);
              res(docRef.path);
              localStorage.removeItem(focusType);
            })
            .catch(function(error) {
              rej(error);
              console.error("Error adding document: ", error);
            });
        });
      });
    },
    addNameNumberPlace({ commit, state }, { nameNumberPlace }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let nameNumberPlaceRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_names_numbers_places");

        nameNumberPlaceRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              let updated = doc.data().updated;
              ++updated;
              let toSave = {
                items: [
                  ...doc.data().items,
                  {
                    ...nameNumberPlace,
                    uid: updated
                  }
                ],
                updated
              };
              return nameNumberPlaceRef.update(toSave).then(() => {
                console.log("Save new name success");
                res({ ...nameNumberPlace, uid: updated });
              });
            } else {
              let toSave = {
                items: [{ ...nameNumberPlace, uid: 0 }],
                updated: 0,
                _created_at: new Date(),
                _deleted_at: null
              };
              return nameNumberPlaceRef.set(toSave).then(() => {
                console.log("Save new name success");
                res({ ...nameNumberPlace, uid: 0 });
              });
            }
          })
          .catch(err => {
            console.log("Error add new name: ", err);
          });
      });
    },
    updateNameNumberPlace({ commit, state }, { nameNumberPlace }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let nameNumberPlaceRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_names_numbers_places");

        nameNumberPlaceRef.get().then(function(doc) {
          let existing = doc.data().items;
          let toSave = existing.map(el => {
            if (el.uid === nameNumberPlace.uid) {
              el = {
                ...nameNumberPlace,
                updated_at: new Date()
              };
            }
            return el;
          });
          res(
            nameNumberPlaceRef
              .update({
                items: toSave
              })
              .then(() => {
                console.log("Update NameNumber Success");
              })
              .catch(err => {
                console.log("Error in update Name Number:", err);
              })
          );
        });
      });
    },
    updateTool({ commit, state }, { tool }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_tools");

        toolRef.get().then(function(doc) {
          let existing = doc.data().items;
          let toSave = existing.map(el => {
            if (el.uid === tool.uid) {
              el = {
                ...tool,
                updated_at: new Date()
              };
            }
            return el;
          });
          res(
            toolRef
              .update({
                items: toSave
              })
              .then(() => {
                console.log("Update Tool Success");
              })
              .catch(err => {
                console.log("Error in update Tool:", err);
              })
          );
        });
      });
    },
    addAnEngines({ commit, state }, { engines }) {
      //Change to the ability of adding an array of commitments
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let engineRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__engines");
        let enginesToSave = engines.filter(el => !el.uid);
        if (!enginesToSave.length) {
          res(engines);
        } else {
          let toSave = {};
          res(
            engineRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  enginesToSave.map(el => (el.uid = ++updated));
                  toSave = {
                    items: [...doc.data().items, ...enginesToSave],
                    updated
                  };
                  return engineRef.update(toSave).then(function() {
                    console.log("Add List Engines Success ");
                    let toSaveElements = [...toSave.items];
                    engines.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return engines;
                    // return toSave.items._elements;
                  });
                } else {
                  enginesToSave.map((el, index) => (el.uid = index));
                  toSave = {
                    items: [...enginesToSave],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: engines.length - 1
                  };
                  return engineRef.set(toSave).then(function() {
                    console.log("Add List Engines Success ");
                    let toSaveElements = [...toSave.items];
                    engines.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return engines;
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
              })
          );
        }
      });
    },
    addEventInEngineInFocus({ commit, state }, { event, focusId, engine_id }) {
      return new Promise((res, rej) => {
        if (event && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          let eventStriped = { ...event };
          delete eventStriped.text;
          delete eventStriped.when;
          delete eventStriped.engine_id;
          delete eventStriped.daysEnabled;
          delete eventStriped.daysPattern;
          delete eventStriped.focus_tool_ids;
          delete eventStriped._created_at;

          res(
            focusRef
              .get()
              .then(doc => {
                let engineFromDatabase = doc.data().engines;
                let engineEdited = engineFromDatabase.map(el => {
                  if (el.engine_id === engine_id) {
                    return {
                      ...el,
                      _events: eventStriped
                    };
                  } else {
                    return el;
                  }
                });
                console.log(engineEdited, "ini yang mau di savee");
                return focusRef
                  .update({
                    engines: engineEdited
                  })
                  .then(() => {
                    console.log("successfully add event in engine in a focus");
                  });
              })
              .catch(err => {
                console.log("error in add event in engine in focus:", err);
              })
          );
        }
      });
    },
    saveEventInLists({ commit, state }, { focus, focusId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let { _duration } = focus;
        let _events = [];
        let dayList = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        let today = dayList[new Date().getDay()];

        let eventsActiveRef = db.doc(
          `users/${state.user.uid}/lists/_events/active/${focusId}`
        );
        let eventsLogRef = db.doc(
          `users/${state.user.uid}/lists/_events/log/${focusId}`
        );

        focus.engines.forEach((el, index) => {
          if (el._events && el._events.days) {
            el._events.days.forEach((elWeek, indexWeek) => {
              let days = { ...elWeek };
              for (let day in days) {
                // let to =
                //   _duration === "6 Weeks" ? 6 : _duration === "1 Week" && 1;
                // if (to) {
                // for (let i = 0; i < to + 1; i++) {
                //   if (
                //     (i === 0 &&
                //       dayList.indexOf(day) >= dayList.indexOf(today)) ||
                //     i > 0
                //   ) {
                let date = moment().day(dayList.indexOf(day) + indexWeek * 7);
                let momentDate = moment(date._d).format("YYYY-MM-DD");
                if (days[day] && days[day].start && days[day].end) {
                  _events.push({
                    _start_at: new Date(
                      moment(momentDate + " " + days[day].start)
                    ),
                    _end_at: new Date(moment(momentDate + " " + days[day].end)),
                    place: days[day].place,
                    engine: el.text
                  });
                }
                //   }
                // }
                // console.log(_events, "ini events logoggoog");
                // } else {
                // console.log(_events, "ini events logoggoog2");
                // let momentDate = moment(new Date()).format("YYYY-MM-DD");

                // _events.push({
                //   _start_at: new Date(
                //     moment(momentDate + " " + days[day].start)
                //   ),
                //   _end_at: new Date(moment(momentDate + " " + days[day].end)),
                //   place: days[day].place,
                //   engine: el.text,
                // });
                // }
              }
            });
          }
        });
        return eventsActiveRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let eventsActive = [...doc.data().events];
              // console.log(
              //   moment(doc.data()._created_at.toDate()).format("DD-MM-YYYY"),
              //   "kokokokokokokokokokokmomookokomoko,mo",
              //   doc.data()._created_at
              // );
              let logs = {
                [moment(doc.data()._created_at.toDate()).unix()]:
                  // .format(
                  // "DD-MM-YYYY")
                  eventsActive
              };

              const updateActiveRef = () => {
                eventsActiveRef
                  .update({
                    _created_at: new Date(),
                    _updated_at: new Date(),
                    events: [..._events]
                  })
                  .then(() => {
                    // console.log("succesfully save in _list => _events");
                    res(true);
                  });
              };

              return eventsLogRef.get().then(doc => {
                if (doc.exists) {
                  eventsLogRef
                    .update({
                      _updated_at: new Date(),
                      logs: { ...doc.data().logs, ...logs }
                    })
                    .then(() => {
                      return updateActiveRef();
                    });
                } else {
                  eventsLogRef
                    .set({
                      _created_at: new Date(),
                      logs: { ...logs }
                    })
                    .then(() => {
                      return updateActiveRef();
                    });
                }
              });
            } else {
              return eventsActiveRef
                .set({
                  _created_at: new Date(),
                  events: [..._events]
                })
                .then(() => {
                  // console.log("succesfully save in _list => _events");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in saving in list => _events: ", err);
          });
      });
    },
    addNames({ commit, state }, { names }) {
      //Change to the ability of adding an array of commitments
      console.log("name", names);
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let namesNumbersPlacesRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_names_numbers_places");

        let namesToSave = names.filter(
          el => !el.uid && el.uid !== 0 && el._created_at
        );
        console.log("up names", names);
        console.log("up namesToSave", namesToSave);
        if (!namesToSave.length) {
          res(names);
        } else {
          let toSave = {};

          res(
            namesNumbersPlacesRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  if (namesToSave.length > 0) {
                    let updated = doc.data().updated;
                    namesToSave.map(el => (el.uid = ++updated));
                    toSave = {
                      items: firebase.firestore.FieldValue.arrayUnion(
                        ...namesToSave.map(el => ({
                          uid: el.uid,
                          info: {
                            nickname: el.nickname,
                            role: el.role
                          },
                          user: el.user
                        }))
                      ),
                      updated
                    };
                    return namesNumbersPlacesRef
                      .update(toSave)
                      .then(function() {
                        let toSaveElements = [
                          ...doc.data().items.map((el, index) => {
                            return {
                              ...el,
                              name: `${el.info.nickname}`,
                              // subText: el.info.lastName,
                              role: namesToSave[0].role,
                              info: undefined
                            };
                          })
                        ];
                        names.map(el => {
                          if (!el.uid) {
                            let newEl = toSaveElements[0];
                            toSaveElements.splice(1);
                            return newEl;
                          }
                        });
                        return names;
                      });
                  } else {
                    return [];
                  }
                } else {
                  if (namesToSave.length > 0) {
                    namesToSave.map((el, index) => (el.uid = index));
                    toSave = {
                      items: [
                        ...namesToSave.map(el => ({
                          uid: el.uid,
                          info: {
                            nickname: el.nickname,
                            role: el.role
                          },
                          user: el.user
                        }))
                      ],
                      _created_at: new Date(),
                      _deleted_at: null,
                      updated: names.length - 1
                    };
                    return namesNumbersPlacesRef.set(toSave).then(function() {
                      console.log("Add List Names Success ");
                      let toSaveElements = [
                        ...toSave.items.map(el => ({
                          ...el,
                          name: el.info.nickname,
                          role: el.info.role,
                          info: undefined
                        }))
                      ];
                      names.map(el => {
                        if (!el.uid) {
                          let newEl = toSaveElements[0];
                          toSaveElements.splice(1);
                          return newEl;
                        }
                      });
                      return names;
                    });
                  } else {
                    return [];
                  }
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
              })
          );
        }
      });
    },
    addTools({ commit, state }, { tools }) {
      //Change to the ability of adding an array of commitments
      return new Promise((res, rej) => {
        const listToolsToolId = state.tools.map(el => el.tooldetail.toolId);
        const db = firebase.firestore(); //Move to single place
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_tools");

        tools = tools.map(el => {
          if (!el.uid) {
            if (listToolsToolId.includes(el.tooldetail.toolId)) {
              el.uid =
                state.tools[listToolsToolId.indexOf(el.tooldetail.toolId)].uid;
            }
          }
          return el;
        });
        let toolsToSave = tools.filter(el => !el.uid);
        toolsToSave = toolsToSave.filter(
          el => !listToolsToolId.includes(el.tooldetail.toolId)
        );

        if (!toolsToSave.length) {
          res(tools);
        } else {
          let toSave = {};

          res(
            toolsRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  toolsToSave.map(el => (el.uid = ++updated));

                  toSave = {
                    items: [...doc.data().items, ...toolsToSave],
                    updated
                  };
                  return toolsRef.update(toSave).then(function() {
                    console.log("Add List Tools Success ");
                    let toSaveElements = [...toSave.items];

                    tools.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return tools;
                  });
                } else {
                  toolsToSave.map((el, index) => (el.uid = index));
                  toSave = {
                    items: [...toolsToSave],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: tools.length - 1
                  };

                  return toolsRef.set(toSave).then(function() {
                    console.log("Add List Tools Success ");

                    let toSaveElements = [...toSave.items];

                    tools.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return tools;
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
              })
          );
        }
      });
    },
    addRoles({ commit, state }, { roles }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let rolesRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_roles");
        res(
          rolesRef
            .get()
            .then(doc => {
              if (doc.exists) {
                let allRoles = doc.data().items.map(el => el.text);
                let filteredRoles = roles.filter(
                  el => !allRoles.includes(el.text)
                );
                let updated = doc.data().updated;
                let filteredRolesWuid = filteredRoles.map(el => ({
                  ...el,
                  uid: ++updated
                }));
                filteredRolesWuid = filteredRolesWuid.filter(role => {
                  role.text;
                });
                if (filteredRolesWuid.length > 0) {
                  return rolesRef
                    .update({
                      items: firebase.firestore.FieldValue.arrayUnion(
                        ...filteredRolesWuid
                      ),
                      updated
                    })
                    .then(() => {
                      console.log("successfully save roles");
                    });
                }
              } else {
                let rolesWuid = roles.map((el, index) => ({
                  ...el,
                  uid: index
                }));
                return rolesRef
                  .set({
                    _created_at: new Date(),
                    items: rolesWuid,
                    updated: roles.length - 1
                  })
                  .then(() => {
                    console.log("successfully save roles");
                  });
              }
            })
            .catch(err => {
              console.log("error in saving roles: ", err);
            })
        );
      });
    },
    addCrewIntoFocus({ commit, state }, { crew, focusId }) {
      return new Promise((res, rej) => {
        if (crew && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .update({
              crew: firebase.firestore.FieldValue.arrayUnion(crew)
            })
            .then(() => {
              console.log("successfully added new crew into a focus");
              res(true);
            })
            .catch(err => {
              console.log("error in adding new crew into focus:", err);
              rej(err);
            });
        }
      });
    },
    addEngineIntoFocus({ commit, state }, { engine, focusId }) {
      return new Promise((res, rej) => {
        if (engine && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .update({
              engines: firebase.firestore.FieldValue.arrayUnion(engine)
            })
            .then(() => {
              console.log("successfully added new engine into a focus");
              res(true);
            })
            .catch(err => {
              console.log("error in adding new engine into focus:", err);
              rej(err);
            });
        }
      });
    },
    editCrewInFocus({ commit, state }, { crew, focusId }) {
      return new Promise((res, rej) => {
        if (crew && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          res(
            focusRef
              .get()
              .then(doc => {
                let crewFromDatabase = doc.data().crew;
                let crewEdited = crewFromDatabase.map(el => {
                  if (
                    el._names_numbers_places_id ===
                    crew._names_numbers_places_id
                  ) {
                    return crew;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    crew: crewEdited
                  })
                  .then(() => {
                    console.log("successfully edit crew in a focus");
                  });
              })
              .catch(err => {
                console.log("error in editing crew in focus:", err);
              })
          );
        }
      });
    },
    editEngineInFocus({ commit, state }, { engine, focusId }) {
      return new Promise((res, rej) => {
        if (engine && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          res(
            focusRef
              .get()
              .then(doc => {
                let engineFromDatabase = doc.data().engines;
                let engineEdited = engineFromDatabase.map(el => {
                  if (el.engine_id === engine.engine_id) {
                    return engine;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    engines: engineEdited
                  })
                  .then(() => {
                    console.log("successfully edit engine in a focus");
                  });
              })
              .catch(err => {
                console.log("error in editing engine in focus:", err);
              })
          );
        }
      });
    },
    removeCrewInFocus(
      { commit, state },
      { _names_numbers_places_id, focusId }
    ) {
      return new Promise((res, rej) => {
        if (_names_numbers_places_id && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .get()
            .then(doc => {
              let crews = doc.data().crew;
              let crewsToSave = crews.map(el => {
                if (el._names_numbers_places_id === _names_numbers_places_id) {
                  return {
                    ...el,
                    _deleted_at: new Date()
                  };
                } else {
                  return el;
                }
              });
              return focusRef
                .update({
                  crew: crewsToSave
                })
                .then(() => {
                  console.log("successfully remove crew from a focus");
                  res(true);
                });
            })
            .catch(err => {
              console.log("error in remove crew from focus:", err);
            });
        }
      });
    },
    removeEngineInFocus({ commit, state }, { engine_id, focusId }) {
      return new Promise((res, rej) => {
        if (typeof +engine_id == "number" && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .get()
            .then(doc => {
              let engines = doc.data().engines;
              let enginesToSave = engines.map(el => {
                if (el.engine_id === engine_id) {
                  return {
                    ...el,
                    _deleted_at: new Date()
                  };
                } else {
                  return el;
                }
              });
              return focusRef
                .update({
                  engines: enginesToSave
                })
                .then(() => {
                  console.log("successfully remove crew from a focus");
                  res(true);
                });
            })
            .catch(err => {
              console.log("error in remove crew from focus:", err);
            });
        }
      });
    },
    addStationReason({ commit, state }, { reason }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let stationRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__station_reasons");

        let reasonToSave =
          reason.uid !== null && reason.uid > -1 ? null : reason;
        if (
          !reasonToSave &&
          (reason.uid === 0 || reason.uid === 1 || reason.uid === 2)
        ) {
          res(reason);
        } else {
          let toSave = {};
          res(
            stationRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  reasonToSave = { ...reasonToSave, uid: ++updated };
                  toSave = {
                    items: firebase.firestore.FieldValue.arrayUnion(
                      reasonToSave
                    ),
                    updated
                  };
                  return stationRef.update(toSave).then(function() {
                    console.log("Add Reason Stationed Success ");

                    return toSave.items._elements
                      ? toSave.items._elements[
                          toSave.items._elements.length - 1
                        ]
                      : null;
                  });
                } else {
                  toSave = {
                    items: [
                      {
                        uid: "a",
                        text: "I do not have enough mouney for this  journey"
                      },
                      { uid: "b", text: "I do not have time" },
                      { uid: "c", text: "I am not interested anymore" },
                      { ...reason, uid: 0 }
                    ],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: 3
                  };
                  return stationRef.set(toSave).then(function() {
                    console.log("Add Reason Stationed Success ");
                    return toSave.items[0];
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
              })
          );
        }
      });
    },
    addJourneys({ commit, state }, journeys) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        let updated = 0;
        journeys.map(el => (el._created_at = new Date()));
        journeysRef.get().then(doc => {
          if (doc.exists) {
            let existingJourneys = doc.data().items;
            updated = doc.data().updated;
            journeys.map((el, index) => (el.uid = updated + index));
            journeysRef
              .update({
                _updated_at: new Date(),
                updated: updated + 1,
                items: [...existingJourneys, ...journeys]
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            journeys.map((el, index) => (el.uid = updated + index));
            journeysRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                _deleted_at: null,
                updated: journeys.length + 1,
                items: [...journeys],
                connections: []
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    addJourney({ commit, state }, journey) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          if (doc.exists) {
            let updated = doc.data().updated;
            journeysRef
              .update({
                updated: updated + 1,
                _updated_at: new Date(),
                items: firebase.firestore.FieldValue.arrayUnion({
                  _created_at: new Date(),
                  uid: updated + 1,
                  ...journey
                })
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            console.log("no hi");
            journeysRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                _deleted_at: null,
                updated: 0,
                items: [],
                connections: []
              })
              .then(() => {
                let updated = 0;
                journeysRef
                  .update({
                    updated: updated + 1,
                    items: firebase.firestore.FieldValue.arrayUnion({
                      _created_at: new Date(),
                      uid: updated + 1,
                      ...journey
                    })
                  })
                  .then(() => {
                    res(true);
                  })
                  .catch(err => {
                    rej(err);
                  });
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    updateJourney({ commit, state }, journey) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === journey.uid) {
              el = { ...el, ...journey, _updated_at: new Date() };
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: JSON.parse(JSON.stringify(newItems))
            })
            .then(() => {
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    saveJourneyImageUrl({ commit, state }, payload) {
      console.log("payload", payload);
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === payload.selectedJourney.uid) {
              el = { ...el, visual: payload.visual };
              console.log("element", el);
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: newItems
            })
            .then(() => {
              commit("SET_JOURNEYS", newItems);
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    deleteJourneyImage({ commit, state }, payload) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === payload.uid) {
              delete el.visual.url;
              delete el.visual.mediaType;
            }
            return el;
          });
          journeysRef
            .update({
              _deleted_at: new Date(),
              items: newItems
            })
            .then(() => {
              commit("SET_JOURNEYS", newItems);
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    storePosition({ commit, state }, payload) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === payload.uid) {
              el = { ...el, coords: payload.coords };
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: newItems
            })
            .then(() => {
              commit("SET_JOURNEYS", newItems);
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    storeConnectionPosition({ commit, state }, payload) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let connections = doc.data().connections;
          let newConnections = connections.map(el => {
            if (el.name === payload.name) {
              el = { ...el, coords: payload.coords };
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: newConnections
            })
            .then(() => {
              commit("SET_CONNECTIONS", newConnections);
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    archiveJourney({ commit, state }, journey) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === journey.uid) {
              el = { ...el, _archived_at: new Date() };
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: newItems
            })
            .then(() => {
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    updateJourneysOrder({ commit, state }, journeys) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef
          .update({
            _updated_at: new Date(),
            items: journeys
          })
          .then(() => {
            res(true);
          })
          .catch(err => {
            rej(err);
          });
      });
    },
    addJourneyConnection({ commit, state }, { connection }) {
      console.log("in add journey connection", connection);
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");
        journeysRef.get().then(doc => {
          if (doc.exists) {
            journeysRef
              .update({
                connections: firebase.firestore.FieldValue.arrayUnion({
                  _created_at: new Date(),
                  _created_by: state.user.uid,
                  ...connection
                })
              })
              .then(() => {
                // commit("SET_JOURNEYS", newItems);
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    updateJourneyConnection({ commit, state }, connection) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().connections;
          let newItems = items.map(el => {
            if (el.id === connection.id) {
              el.data.selectedbinding = connection.data.selectedbinding;
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              connections: JSON.parse(JSON.stringify(newItems))
            })
            .then(() => {
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    removeJourneyConnection({ commit, state }, element) {
      console.log("in remove journey connection", element);
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");
        journeysRef.get().then(doc => {
          if (doc.exists) {
            console.log("in true");
            journeysRef
              .update({
                connections: firebase.firestore.FieldValue.arrayRemove(element)
              })
              .then(() => {
                console.log("in then");
                // commit("SET_JOURNEYS", newItems);
                res(true);
              })
              .catch(err => {
                console.log("in catch");
                rej(err);
              });
          }
          // let newItems = connections.foreach((element, index) => {
          //   if (ind === index) {
          //     console.log("in if where index matched", ind, index);
          //     element = { ...element, _archived_at: new Date() };
          //   }
          //   return element;
          // })
          // if (doc.exists) {
          //   journeysRef
          //     .update({
          //       connections: newItems
          //     })
          //     .then(() => {
          //       // commit("SET_JOURNEYS", newItems);
          //       res(true);
          //     })
          //     .catch(err => {
          //       rej(err);
          //     });
          // }
        });
      });
    },
    addStatesFocusesNotif({ commit, state }, { crewNotify, focusId }) {
      const db = firebase.firestore();
      let statesFocusesRef = db.collection("states").doc("focuses");

      if (crewNotify.length) {
        let newStateFocusesList = crewNotify.map((aCrewMember, index) => {
          let output = {
            _created_at: new Date(),
            state: "notified",
            focus: db.doc(`users/${state.user.uid}/focuses/${focusId}`),
            email: aCrewMember.user.email
          };

          if (aCrewMember.user && aCrewMember.user.userId) {
            return {
              ...output,
              user: db.doc(`users/${aCrewMember.user.userId}`)
            };
          } else {
            return output;
          }
        });

        statesFocusesRef
          .update({
            focuses: firebase.firestore.FieldValue.arrayUnion(
              ...newStateFocusesList
            )
          })
          .then(() => {
            console.log("added new state focuses list successfully");
          })
          .catch(err => {
            console.log("Error in adding new state focuses:", err);
          });
      }
    },
    addAnEmote({ commit, state }, { emote }) {
      //Change to the ability of adding an array of commitments
      const db = firebase.firestore(); //Move to single place
      let myFirebaseFirestoreTimestampFromDate = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      emote._created_at = myFirebaseFirestoreTimestampFromDate;

      let emoteDocRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tools")
        .doc("emote");
      emoteDocRef
        .update({
          trackings: firebase.firestore.FieldValue.arrayUnion(emote)
        })
        .then(function() {
          console.log("Emote Logged");
        })
        .catch(function(error) {
          console.error("Error adding Emote log: ", error);
        });
    }, //Move to tools
    logACheckIn({ commit, state }, { checkin }) {
      //Change to the ability of adding an array of commitments
      const db = firebase.firestore(); //Move to single place
      let myFirebaseFirestoreTimestampFromDate = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      checkin._created_at = myFirebaseFirestoreTimestampFromDate;

      let checkinDocRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tools")
        .doc("checkin");
      checkinDocRef
        .update({
          logs: firebase.firestore.FieldValue.arrayUnion(checkin)
        })
        .then(function() {
          console.log("CheckIn Logged");
        })
        .catch(function(error) {
          console.error("Error adding  Check-In log: ", error);
        });
    }, //Move to tools
    findingAUserByEmail({ commit, state }, { email }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const userRef = db.collection("users").where("email", "==", email);
        userRef
          .get()
          .then(function(querySnapshot) {
            let isExist = false;
            querySnapshot.forEach(function(doc) {
              if (doc.exists) {
                isExist = true;
                res({ ...doc.data(), uid: doc.id });
                commit("SET_FIND_A_USER", {
                  findAUser: { ...doc.data(), uid: doc.id }
                });
              }
            });
            if (!isExist) {
              res(null);
              commit("SET_FIND_A_USER", { findAUser: null });
            }
          })
          .catch(err => [rej(err)]);
      });
    },
    actionResponseInvitationJourney({ commit, state, dispatch }, payload) {
      const { notif, response } = payload;
      const { user, names } = state;
      let listNamesUid = names.map(el => el.uid);
      const db = firebase.firestore(); //@TODO- Move to single place

      const stateFocusesRef = db.doc("states/focuses");
      const focusRef = notif.focus;
      const notifRef = db.doc(`users/${user.uid}/lists/__notifications`);
      const joinsRef = db.doc(`users/${user.uid}/lists/__joins`);

      //Update Main State for Focuses
      stateFocusesRef
        .get()
        .then(doc => {
          let stateFocusesList = [...doc.data().focuses];
          stateFocusesList = stateFocusesList.map((el, index) => {
            if (
              el.focus.path === notif.focus.path &&
              el.user &&
              el.user.id === user.uid
            ) {
              return {
                ...el,
                state: response,
                _updated_at: new Date()
              };
            }
            return el;
          });
          return stateFocusesRef
            .update({
              focuses: stateFocusesList
            })
            .then(() => {
              console.log("successfully updated state.focuses");

              // let nameToSave;

              return focusRef.get().then(doc => {
                let crews = [...doc.data().crew];
                let destination = doc.data().destination;

                // return dispatch('getListNamesOtherUser', {uid: notif.user_from.id})
                // .then((data) => {
                // console.log(data, "ini data hasil get names list orang lain yah")
                // let focusOwnerNames = data.items
                let newCrews = crews.map((el, index) => {
                  if (
                    el.connection &&
                    el.connection.user &&
                    el.connection.user.id === user.uid
                  ) {
                    let output = {
                      ...el,
                      join_status: response
                    };
                    if (response === "Ignore") {
                      output._rejected_at = new Date();
                    } else if (response === "joined") {
                      // nameToSave = el.text;
                      output._joined_at = new Date();
                    }
                    return output;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    crew: newCrews
                  })
                  .then(() => {
                    console.log("successfully updated user.focuses.crew");

                    return notifRef.get().then(doc => {
                      let notifs = [...doc.data().items];

                      notifs = notifs.map((el, index) => {
                        if (
                          el.type === "join-invite" &&
                          el.focus.id === notif.focus.id &&
                          el.user_from.user
                        ) {
                          return {
                            ...el,
                            _answered_at: new Date(),
                            _answer: response
                          };

                          /*@TODO- Add notification that the user haev joined- ask user if they want to see their joins */
                        } else {
                          return el;
                        }
                      });

                      return notifRef
                        .update({
                          _updated_at: new Date(),
                          items: notifs
                        })
                        .then(() => {
                          console.log("successfully update __notifications");
                          if (response === "joined") {
                            let user = notif.user_from.user;
                            return user.get().then(userFromDoc => {
                              let {
                                imgURL,
                                firstname,
                                lastname
                              } = userFromDoc.data();
                              return joinsRef.get().then(doc => {
                                let newJoin = {
                                  _created_at: new Date(),
                                  _joined_at: new Date(),
                                  destination: destination.text1,
                                  focus: notif.focus,
                                  user: notif.user_from
                                };
                                if (imgURL) newJoin.imgURL = imgURL;
                                if (firstname) newJoin.firstname = firstname;
                                if (lastname) newJoin.lastname = lastname;
                                // if (nameToSave) newJoin.alias = nameToSave;

                                if (doc.exists) {
                                  return joinsRef
                                    .update({
                                      focuses: [...doc.data().focuses, newJoin]
                                    })
                                    .then(() =>
                                      console.log("successfully save in joinn")
                                    );
                                } else {
                                  return joinsRef
                                    .set({
                                      focuses: [newJoin]
                                    })
                                    .then(() =>
                                      console.log("successfully save in joinn")
                                    );
                                }
                              });
                            });
                          }
                        });
                    });
                  });
                // })
              });
            });
        })
        .catch(err => {
          console.log("there are errors in joining/rejecting invitation", err);
        });
    },
    addToDone({ commit, state }, { toDone }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const toDoneRef = db.doc(`users/${state.user.uid}/lists/__todone`);

        return toDoneRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let toDones = [...doc.data().items];
              return toDoneRef
                .update({
                  items: [...toDones, { ...toDone }]
                })
                .then(() => {
                  console.log("successfully save toDone");
                  res(true);
                });
            } else {
              return toDoneRef
                .set({
                  _created_at: new Date(),
                  items: [{ ...toDone }]
                })
                .then(() => {
                  console.log("successfully save toDone");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save toDone: ", err);
            rej(err);
          });
      });
    },
    getToDone({ commit, state }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let toDoneRef = db.doc(`users/${state.user.uid}/lists/__todone`);
        toDoneRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            commit("SET_TO_DONE", { toDone: snapshot.data().items });
            res(snapshot.data().items);
          }
        });
      });
    },
    removeToDone({ commit, state }, { toDone }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let toDoneRef = db.doc(`users/${state.user.uid}/lists/__todone`);
        return toDoneRef
          .get()
          .then(doc => {
            let toDones = [...doc.data().items];
            toDones = toDones.map(el => {
              if (el.text === toDone.text) {
                return {
                  ...el,
                  _deleted_at: new Date()
                };
              }
              return el;
            });
            return toDoneRef
              .update({
                items: toDones
              })
              .then(() => {
                console.log("successfully remove toDone");
                res(true);
              });
          })
          .catch(err => {
            console.log("error in removing toDone: ", err);
            rej(err);
          });
      });
    },
    setToolInEngineOnOrOff(
      { commit, state },
      { focusId, type, engine_id, toolUid }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(`users/${state.user.uid}/focuses/${focusId}`);
        return focusRef
          .get()
          .then(doc => {
            let engines = doc.data().engines;
            engines = engines.map(el => {
              if (el.engine_id === engine_id) {
                if (type === "on") {
                  el.focus_tool_ids.push({
                    _created_at: new Date(),
                    uid: toolUid
                  });
                } else {
                  el.focus_tool_ids = el.focus_tool_ids.filter(
                    e => e.uid !== toolUid
                  );
                }
              }
              return el;
            });
            return focusRef
              .update({
                engines: engines
              })
              .then(() => {
                console.log("successfully turn off/on a tool from an engine");
                res(true);
              });
          })
          .catch(err => {
            console.log("error while turn off/on a tool from an engine: ", err);
            rej(err);
          });
      });
    },
    getUserDeviceRegistrationToken({ commit, state }) {
      const messaging = firebase.messaging();
      const db = firebase.firestore();
      const userRef = db.collection("users").doc(state.user.uid);

      const saveTokenToDbToken = token => {
        const deviceItem = {
          token,
          _created_at: new Date()
        };

        userRef.get().then(doc => {
          if (!doc.data().device_registratons) {
            userRef
              .set(
                {
                  device_registratons: [deviceItem]
                },
                { merge: true }
              )
              .catch(function(err) {
                if (err) {
                  console.log(err.stack);
                }
              });
          } else {
            const devices = doc.data().device_registratons;

            // find tokens in the db
            const index = Array.isArray(devices)
              ? devices.findIndex(val => val.token === token)
              : -1;

            // if already exists ignore updates
            if (index === -1) {
              // devices.push(deviceItems)
              userRef
                .update({
                  device_registratons: [deviceItem]
                })
                .catch(function(err) {
                  if (err) {
                    console.log(err.stack);
                  }
                });
            }
          }
        });
      };

      // Callback fired if Instance ID token is updated.
      messaging.onTokenRefresh(() => {
        messaging
          .getToken()
          .then(refreshedToken => {
            console.log("Token refreshed.");
            saveTokenToDbToken(refreshedToken);
          })
          .catch(err => {
            console.log("Unable to retrieve refreshed token ", err);
            commit("SET_DEVICE_REGISTRATION_TOKEN", false);
          });
      });
      // token request
      messaging
        .requestPermission()
        .then(function() {
          // get the token in the form of promise
          return messaging.getToken();
        })
        .then(function(token) {
          saveTokenToDbToken(token);
          commit("SET_DEVICE_REGISTRATION_TOKEN", token);
        })
        .catch(function(err) {
          if (err) {
            console.log(err.stack);
          }
          commit("SET_DEVICE_REGISTRATION_TOKEN", false);
        });

      messaging.onMessage(function(payload) {
        console.log("Message received. ", payload);
      });
    },
    /* GUIDE */
    getGuideSessions({ commit, state }, uid) {
      return new Promise((res, rej) => {
        let id = null;
        if (uid) {
          id = uid;
        } else {
          id = state.user.uid;
        }
        let db = firebase.firestore();
        const timesRef = db.doc(`users/${id}/lists/__guide_availability`);
        return timesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let times = [...doc.data().timings];
              res(times);
            } else {
              res();
            }
          })
          .catch(err => {
            console.log("Error in getting available times: ", err);
            rej(err);
          });
      });
    },
    saveGuideProfileName({ commit, state }, profileName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.guide = {
            ...data._dashboards.guide,
            _updated_at: new Date(),
            profileName: profileName
          };
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateGuideDashboard({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards = {
            ...data._dashboards,
            guide: {
              _created_at: new Date(),
              _account: {
                _created_at: new Date(),
                type: "free",
                status: "active"
              }
            }
          };
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    /* TRACK */
    createTrack({ commit, state }, track) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const tracksRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        tracksRef
          .get()
          .then(doc => {
            if (doc.exists) {
              tracksRef.update({
                tracks: [...doc.data().tracks, track],
                _updated_at: new Date()
              });
            } else {
              tracksRef.set({
                _created_at: new Date(),
                tracks: [track]
              });
            }
            res(true);
          })
          .catch(err => {
            console.log("error in saving list guide sessions1:", err);
          });
      });
    },
    getListTracks({ commit, state }) {
      return new Promise((res, rej) => {
        let trackType = "guide";

        const db = firebase.firestore();
        let _tracksRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc(`__${trackType}_tracks`);

        _tracksRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().tracks && doc.data().tracks.length) {
              res(doc.data().tracks);
            } else {
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error in getting blogs: ", error);
            rej(error);
          });
      });
    },
    updateTrack({ commit, state }, track) {
      console.log("t =>", track);
      let roles = [];
      let weeks = 0;
      let price = 0;
      let categories = "";
      let languages = [];
      let age = 3;
      let leaningStyle = "";
      let copyright = "";
      if (track.roles != undefined) {
        roles = track.roles;
      }
      if (track.weeks != undefined) {
        weeks = track.weeks;
      }
      if (track.price != undefined) {
        price = track.price;
      }
      if (track.categories != undefined) {
        categories = track.categories;
      }
      if (track.languages != undefined) {
        languages = track.languages;
      }
      if (track.age != undefined) {
        age = track.age;
      }
      if (track.leaningStyle != undefined) {
        leaningStyle = track.leaningStyle;
      }
      if (track.copyright != undefined) {
        copyright = track.copyright;
      }
      return new Promise((res, rej) => {
        let trackType = "guide";

        const db = firebase.firestore();
        const tracksRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return tracksRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == track.id) {
              aTrack._updated_at = new Date();
              aTrack.title = track.title;
              aTrack.detail = track.detail;
              aTrack.spheres = track.spheres;
              aTrack.seo = track.seo;
              aTrack.tools = track.tools;
              aTrack.guides = track.guides;
              aTrack.engines = track.engines;
              aTrack.connections = track.connections;
              aTrack.imgURL = track.imgURL;
              aTrack.roles = roles;
              aTrack.weeks = weeks;
              aTrack.price = price;
              aTrack.categories = categories;
              aTrack.languages = languages;
              aTrack.age = age;
              aTrack.leaningStyle = leaningStyle;
              aTrack.copyright = copyright;
            }
          });
          return tracksRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    deleteTrack({ commit, state }, track) {
      return new Promise((res, rej) => {
        let trackType = "guide";

        const db = firebase.firestore();
        let tracks = [];
        const tracksRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        tracksRef.get().then(snapShot => {
          tracks = snapShot.data().tracks;
          tracks.forEach(aTrack => {
            if (aTrack.id == track.id) {
              tracksRef
                .update({
                  tracks: firebase.firestore.FieldValue.arrayRemove(aTrack)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating blog:", e);
                });
            }
          });
        });
      });
    },
    submitTrack({ commit, state }, track) {
      return new Promise((res, rej) => {
        let trackType = "guide";

        const db = firebase.firestore();
        const trackRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == track.id) {
              aTrack.status = "submitted";
              aTrack._submitted_at = new Date();
            }
          });
          return trackRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addTrackVideo({ commit, state }, { id, video }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack.video = video;
              aTrack._updated_at = new Date();
            }
          });
          return trackRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    saveTubeviewToolData({ commit, state }, { id, video, name }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        // let id = id;
        // let video = video;
        // let name = name;
        const db = firebase.firestore();
        const trackRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack.tools.forEach(el => {
                if (el.name == name) {
                  el.plan = {
                    ...video,
                    _created_by: db.doc(`users/${video._created_by}`)
                  };
                }
              });
            }
          });
          return trackRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateTrackVideoThumbnail({ commit, state }, { id, thumbnail }) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        const trackRef = db.doc(
          `users/${state.user.uid}/lists/__${trackType}_tracks`
        );
        let trackVideo = null;
        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tracks.forEach(aTrack => {
            if (aTrack.id == id) {
              aTrack._updated_at = new Date();
              aTrack.video._updated_at = new Date();
              aTrack.video._thumb_at = new Date();
              aTrack.video.videoThumb = thumbnail;
              aTrack._updated_at = new Date();
              trackVideo = aTrack.video;
            }
          });
          return trackRef
            .update({
              ...data
            })
            .then(function() {
              let listingTrackRef = db
                .collection("listings/tracks_guide/items")
                .doc(id);
              listingTrackRef
                .get()
                .then(function(doc) {
                  let track = doc.data();
                  track.doc.video = trackVideo;

                  return listingTrackRef
                    .update(track)
                    .then(function() {
                      console.log("Track Successfully updated!");
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating Blog: ", error);
                      rej(error);
                    });
                })
                .catch(function(error) {
                  console.log("Error getting document:", error);
                  rej(error);
                });
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    /* FOCUS */
    updateFocus({ commit, state }, { focusId, destination }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focusId);
        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.destination = {
            detail: destination.detail,
            text1: destination.text1,
            text2: destination.text2
          };
          return focusRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusEngines({ commit, state }, { engines, focus }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);

        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.engines = engines;
          data._updated_at = new Date();
          console.log("dataEngin", data);
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusCrew({ commit, state }, { crew, focus }) {
      return new Promise((res, rej) => {
        console.log(focus.focusId);
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);

        return focusRef.get().then(doc => {
          let data = { ...doc.data() };

          data.crew = crew;
          data._updated_at = new Date();
          console.log("dataCrew", data);
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusTools({ commit, state }, { tools, focus }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);

        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.tools = tools;
          data._updated_at = new Date();
          console.log("dataTools", data);
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusState({ commit, state }, { focusState, focus }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);
        let focuses = state.focuses;
        let index = 0;
        focuses.forEach(focus => {
          if (focus.state == focusState) {
            index++;
          }
        });
        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.state = focusState;
          data.position = index;
          data._updated_at = new Date();
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusSpheres({ commit, state }, { focusId, spheres }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focusId);

        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data._updated_at = new Date();
          data.spheres = spheres;
          return focusRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    archiveFocus({ commit, state }, focusId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focusId);
        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data._archived_at = new Date();
          return focusRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    getListImages({ commit, state }) {
      console.log("in store");
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("listings")
          .doc("journey_assets")
          .collection("items")
          .doc("images")
          .collection("items");

        toolsRef
          .get()
          .then(querySnapshot => {
            console.log(querySnapshot);
            let images = [];
            querySnapshot.forEach(document => {
              // console.log(document.id, "=>", document.data().imgURL);
              images.push(document.data().imgURL);
              commit("SET_ALL_IMAGES", images);
            });
          })
          .catch(function(error) {
            console.error("Error get list Images: ", error);
          });
      });
    },
    /* TUTORIAL */
    blogTutorialPlayed({ commit, state }, type) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userRef = db.collection("users").doc(state.user.uid);
        let item = null;
        if (type == "gotIt") {
          item = {
            _video_at: new Date()
          };
        } else if (type == "takeTour") {
          item = {
            _tour_at: new Date(),
            _video_at: new Date()
          };
        }
        return userRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data.tutorial) {
            if (data.tutorial.manage) {
              if (data.tutorial.manage.blog) {
                if (data.tutorial.manage.blog.tut1234) {
                  data.tutorial.manage.blog.tut1234.push(item);
                } else {
                  data.tutorial.manage.blog = {
                    tut1234: [item]
                  };
                }
              } else {
                data.tutorial.manage = {
                  ...data.tutorial.manage,
                  blog: {
                    tut1234: [item]
                  }
                };
              }
            } else {
              data.tutorial = {
                ...data.tutorial,
                manage: {
                  blog: {
                    tut1234: [item]
                  }
                }
              };
            }
          } else {
            data.tutorial = {
              manage: {
                blog: {
                  tut1234: [item]
                }
              }
            };
          }
          return userRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    showNotification({ commit, state }, { title, description, variant }) {
      let bootStrapToaster = new BToast();
      bootStrapToaster.$bvToast.toast(description, {
        title: title,
        variant: variant,
        solid: true,
        toastClass: "toast-top"
      });
    },
    getEarlyAccess({ commit, state }, { email, ip }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let data = db.collection("_beta_users").doc("info");
        data.update({ count: increment });

        db.collection("_beta_users")
          .doc("info")
          .collection("emails")
          .get()
          .then(snap => {
            let count = snap.size; // will return the collection size
            commit("SET_COUNT", count);
          });

        db.collection("_beta_users")
          .doc("info")
          .collection("emails")
          .add({
            _created_at: new Date(),
            _updated_at: new Date(),
            _deleted_at: null,
            email: email,
            ip_address: ip
          })
          .then(docRef => {
            res(docRef.id);
          })
          .catch(error => {
            console.error("Error adding document: ", error);
          });
      });
    },
    addBookMarkBlog({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let blogRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blog_bookmarks");
        blogRef.get().then(doc => {
          if (doc.exists) {
            let existingBookmarks = doc.data().items;
            existingBookmarks.push({
              id: blog.id,
              _created_at: new Date()
            });
            blogRef
              .update({
                _updated_at: new Date(),
                items: existingBookmarks
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            blogRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                items: [
                  {
                    id: blog.id,
                    _created_at: new Date()
                  }
                ]
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    removeBookMarkBlog({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bookmarks = [];
        let blogRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blog_bookmarks");
        blogRef.get().then(snapShot => {
          bookmarks = snapShot.data().items;
          bookmarks.forEach(aBookmark => {
            if (aBookmark.id == blog.id) {
              blogRef
                .update({
                  items: firebase.firestore.FieldValue.arrayRemove(aBookmark)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating blog bookmarks:", e);
                });
            }
          });
        });
      });
    },
    getUserBlogBookMarks({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userBlogRef = db
          .collection("users")
          .doc(uid)
          .collection("lists")
          .doc("__blog_bookmarks");

        userBlogRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().items && doc.data().items.length) {
              res(doc.data().items);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error get user bookmarks: ", error);
            rej(error);
          });
      });
    },
    followBlogger({ commit, state }, blogger) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let blogRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blog_followed");
        blogRef.get().then(doc => {
          if (doc.exists) {
            let existingBloggers = doc.data().bloggers;
            existingBloggers.push(blogger);
            blogRef
              .update({
                _updated_at: new Date(),
                bloggers: existingBloggers
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            blogRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                _deleted_at: null,
                bloggers: [blogger]
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    unfollowBlogger({ commit, state }, blogger) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggers = [];
        let blogRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blog_followed");
        blogRef.get().then(snapShot => {
          bloggers = snapShot.data().bloggers;
          bloggers.forEach(aBlogger => {
            if (aBlogger.bloggerId == blogger.bloggerId) {
              blogRef
                .update({
                  bloggers: firebase.firestore.FieldValue.arrayRemove(aBlogger)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating follow:", e);
                });
            }
          });
        });
      });
    },
    getFollowedBloggers({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userBlogRef = db
          .collection("users")
          .doc(uid)
          .collection("lists")
          .doc("__blog_followed");

        userBlogRef
          .get()
          .then(function(doc) {
            if (
              doc.exists &&
              doc.data().bloggers &&
              doc.data().bloggers.length
            ) {
              res(doc.data().bloggers);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error get user followed bloggers: ", error);
            rej(error);
          });
      });
    },
    addBlogTags({ commit, state }, tags) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userBlogRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blog_tags");

        userBlogRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              let existingTags = doc.data().tags;
              let allTags = [...existingTags, ...tags];
              let uniq = [...new Set(allTags)];
              userBlogRef
                .update({
                  _updated_at: new Date(),
                  tags: uniq
                })
                .then(() => {
                  res(true);
                })
                .catch(err => {
                  rej(err);
                });
            } else {
              userBlogRef
                .set({
                  _created_at: new Date(),
                  _updated_at: new Date(),
                  _deleted_at: null,
                  tags: tags
                })
                .then(() => {
                  res(true);
                })
                .catch(err => {
                  rej(err);
                });
            }
          })
          .catch(function(error) {
            console.error("Error adding blog tags: ", error);
            rej(error);
          });
      });
    },
    getBlogTags({ commit, state }, tags) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let userBlogRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blog_tags");

        userBlogRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().tags && doc.data().tags.length) {
              res(doc.data().tags);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error getting blog tags: ", error);
            rej(error);
          });
      });
    }
  },
  mutations: {
    SET_HEARTBEAT_APPS(state, { uid, apps }) {
      debugger;
      if (!state.heartbeatInfos[uid]) state.heartbeatInfos[uid] = {};
      state.heartbeatInfos[uid].apps = apps;
    },
    SET_HEARTBEAT_FAMILY(state, { uid, family }) {
      debugger;
      if (!state.heartbeatInfos[uid]) state.heartbeatInfos[uid] = {};
      state.heartbeatInfos[uid].family = family;
    },
    SET_PUBLISHINGS(state, publishings) {
      if (publishings.length) {
        state.publishings = publishings;
      } else {
        state.publishings = [];
      }
    },
    SET_APPS(state, apps) {
      if (apps.length) {
        state.apps = apps;
      } else {
        state.apps = [];
      }
    },
    SET_APPS_SETTINGS(state, { appId, settings }) {
      let trueAppId = `app_${appId}`; //to prevent from setting with a starting number
      state.appsSettings[trueAppId] = settings && appId ? settings : {};
    },
    SET_APPS_DATA(state, { appId, data }) {
      let trueAppId = `app_${appId}`; //to prevent from setting with a starting number
      state.appsData[trueAppId] = data && appId ? data : {};
    },
    SET_FAMILY(state, family) {
      if (family.length) {
        state.family = family;
      } else {
        state.family = [];
      }
    },
    SET_HEARTBEATS(state, heartbeats) {
      if (Array.isArray(heartbeats)) {
        state.heartbeats = heartbeats;
      }
    },
    SET_BOOKS(state, books) {
      if (books) {
        state.books = books;
      } else {
        state.books = [];
      }
    },
    UPDATED_FOCUS_POSITION(state, items) {
      state.focusesPosition.push(items);
    },
    UPDATE_USER(state, { user }) {
      state.user = user;
      // console.log('here update user',state.user);
    },
    SET_PROFILE(state, profile) {
      if (profile) {
        state.profile = profile;
      } else {
        state.profile = {};
      }
    },
    SET_TOUR_STATUS(state, status) {
      if (status) {
        state.tourStatus = status;
      }
    },
    SET_NAMES_NUMBERS_PLACES(state, namesNumbersPlaces) {
      if (namesNumbersPlaces) {
        state.namesNumbersPlaces = namesNumbersPlaces;
      } else {
        state.namesNumbersPlaces = {};
      }
    },
    SET_NAMES(state, names) {
      if (names.length) {
        state.names = names;
      } else {
        state.names = [];
      }
    },
    SET_TOOLS(state, tools) {
      if (tools.length) {
        state.tools = tools;
      } else {
        state.tools = [];
      }
    },
    SET_JOURNEYS(state, journeys) {
      if (journeys.length) {
        state.journeys = journeys;
      } else {
        state.journeys = [];
      }
    },
    SET_CONNECTIONS(state, connections) {
      if (connections.length) {
        state.connections = connections;
      } else {
        state.connections = [];
      }
    },
    SET_EVENTS(state, events) {
      if (events.length) {
        state.events = events;
      }
    },
    SET_SESSIONS(state, sessions) {
      if (Array.isArray(sessions) && sessions.length) {
        state.sessions = [... sessions];
      }
    },
    SET_CARE_PLANS(state, plans) {
      if (Array.isArray(plans) && plans.length) {
        state.carePlans = [... plans];
      }
    },
    SET_GUIDE_SESSIONS(state, sessions) {
      if (sessions.length) {
        state.guideSessions = sessions;
      }
    },
    SET_NOTIFICATIONS(state, notifications) {
      if (notifications.length) {
        state.notifications = notifications;
      } else {
        state.notifications = [];
      }
    },
    SET_FOCUSES(state, focuses) {
      if (focuses) {
        state.focuses = focuses;
      } else {
        state.focuses = [];
      }
    },
    SET_TAGS(state, { status }) {
      state.status = status;
    },
    SET_LISTS(state, { lists }) {
      state.lists = lists;
    },
    SET_LIST_ENGINE(state, list) {
      if (list.length) {
        state.listEngine = list;
      } else {
        state.listEngine = [];
      }
    },
    SET_STATUS(state, { status }) {
      state.status = status;
    },
    SET_ERROR(state, { error }) {
      state.error = error;
    },
    SET_ROLES(state, { roles }) {
      state.roles = roles;
    },
    SET_RELATIONS(state, { relations }) {
      state.relations = relations;
    },
    SET_FIND_A_USER(state, { user }) {
      state.findAUser = user;
    },
    SET_JOINS(state, joins) {
      if (joins) {
        state.joins = joins;
      } else {
        state.joins = {};
      }
    },
    SET_LIST_TOOLS_CONNECTED_USERS(state, listTool) {
      if (listTool) {
        state.listConnectedUsersTools.push(listTool);
      }
    },
    SET_TO_DONE(state, { toDone }) {
      if (toDone) {
        state.toDone = toDone;
      }
    },
    SET_SCHEDULES(state, { schedules }) {
      if (schedules) {
        state.schedules = schedules;
      }
    },
    SET_SCHEDULE_EVENTS(state, { scheduleEvents }) {
      if (scheduleEvents) {
        state.scheduleEvents = scheduleEvents;
      }
    },
    SET_LIST_NAMES_CONNECTED_USERS(state, listNames) {
      if (listNames) {
        state.listConnectedUsersNames.push(listNames);
      }
    },
    SET_JOIN_TOOLS(state, tools) {
      if (tools) {
        state.joinTools[tools.uid] = tools.tools;
      }
    },
    SET_DEVICE_REGISTRATION_TOKEN(state, token) {
      if (!token) {
        state.notificationPermission = false;
      } else {
        state.userDevice.push(token);
        state.notificationPermission = true;
      }
    },
    SET_ALL_IMAGES(state, images) {
      if (images) {
        state.allImages = images;
      } else {
        state.allImages = [];
      }
    },
    SET_COUNT(state, userCount) {
      if (userCount) {
        state.userCount = userCount;
      }
    }
  }
};

function setLocalStorageUserData(response) {
  console.log(response);
  const { user } = response;
  const { uid, displayName, photoURL, email, phoneNumber, _beta } = user;

  localStorage.setItem("userData", JSON.stringify(response.user));
  localStorage.setItem("uid", uid);
  localStorage.setItem(
    "firstName",
    displayName ? displayName.split(" ")[0] : ""
  );
  localStorage.setItem(
    "lastName",
    displayName
      ? displayName
          .split(" ")
          .slice(1)
          .join(" ")
      : ""
  );
  localStorage.setItem("photoURL", photoURL);
  localStorage.setItem("email", email);
  localStorage.setItem("phoneNumber", phoneNumber);
  localStorage.setItem("_beta", _beta);
}

function removeLocalStorageUserData() {
  localStorage.removeItem("userData");
  localStorage.removeItem("uid");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("photoURL");
  localStorage.removeItem("email");
  localStorage.removeItem("phoneNumber");
}
